import { CapacityRefreshMode, ConsiderSkillMode, Diagram, ResourceSlot, ResourceWithSlots } from "./capacityDiagram.js";
import { BrowserStorageType, Helper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import { ResourcePlanningHelper } from "../core/util/resourcePlanningHelper.js";
import {
    AssignmentType,
    GeomapViewMode,
    GetRosterInfoFromArray,
    IsEventType,
    IsHalfHoliday,
    IsHoliday,
    IsWeekend,
    Kennungstyp,
    RenderWholeDaysMode,
    ResourcePlanningSchedulerActions,
    ResourcePlanningSchedulerDataViewModel,
    ResourcePlanningSchedulerEventViewModel,
    ResourcePlanningSchedulerResourceViewModel,
    ResourcePlanningSchedulerSettingsViewModel,
    RosterDayInfoViewModel
} from "./resourcePlanningScheduler.js";
import { RouteColors } from "../geomap/geomapRPCService.js";
import { FixMode, MultiSelectAction } from "./multiselectHelper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { DateTimePicker } from "../core/components/dateTimePicker.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { OpenStatusSendDialog } from "./dialogs/statusSendDialog.js";
import { SplittingDialogResult, SplittingDialogUtil } from "./splittingDialog/util.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { StyleHelper } from "../style/style.js";
import { SlotSearchSettings } from "./workList.js";
import { JourneyHelper } from "../core/util/journeyHelper.js";
import { DefaultProfilePictureGenerator } from "../core/util/defaultProfilePictureGenerator.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";

export class Scheduler extends React.Component<SchedulerProps, { capacityIsOn?: boolean, lastSelectedRow?: string }> {
    private _dps: DayPilot.Scheduler;
    private _dayPilotDiv: HTMLDivElement;
    private resizeObserver: ResizeObserver;

    private _timeResolutionTypes = {
        "Hours": 0,
        "Days": 1,
        "Week": 2,
        "Month": 3
    }
    /*private sendeStatus = {
        unbelegt: 0,
        zuSenden: 1,
        versendet: 2,
        abgeholt: 3
    }*/

    private _currentlySelectedEventId: string = null;
    private _capacityDiagram: Diagram = null;
    private _schedulerCurrentX = 0;
    private _assignmentArea: JQuery = null;
    private _ctrlPressed = false;
    private _eventContextMenu: DayPilot.Menu = null;
    private _selectionContextMenu: DayPilot.Menu = null;
    private _resourceContextMenu: DayPilot.Menu = null;
    private _topResource: string = null;
    private readonly _format: string = "dd/MM/yyyy";
    private _timeHeaderIndexWeek: number = -1;
    private _colorsAssigmentGrouping: Array<ColorsWithId> = [];
    private _safeColors: any = null;
    protected _trAirLine: string;
    protected _trThere: string;
    protected _trBack: string;
    protected _trKm: string;
    protected _freeSlot: string;
    private _dpsToday: DayPilot.Date;
    private _showOnlyWorkTime: boolean;
    private _schedulerTimeRangeSelectingArgs: DayPilot.SchedulerTimeRangeSelectingArgs = null;

    private _data: ResourcePlanningSchedulerDataViewModel;
    //private _resourceCache: Map<string, ResourcePlanningSchedulerResourceViewModel>;
    private columnTemplate: (data: any) => string;

    public getData(): ResourcePlanningSchedulerDataViewModel {
        return this._data;
    }

    public getCapacityDiagram(): Diagram {
        return this._capacityDiagram;
    }

    private dayPilotDateDiffInDays(startDate: DayPilot.Date, endDate: DayPilot.Date) {
        if (!startDate || !endDate)
            return 0;

        const startClean = new DayPilot.Date(startDate.getDatePart());
        const endClean = new DayPilot.Date(endDate.getDatePart());
        const dur = new DayPilot.Duration(startClean, endClean);
        return dur.days();
    }
    private isDayPilotDateInBetween(date: DayPilot.Date, start: DayPilot.Date, end: DayPilot.Date) {
        if (!date || !start || !end)
            return false;
        const dateClean = new DayPilot.Date(date.getDatePart());
        const startClean = new DayPilot.Date(start.getDatePart());
        const endClean = new DayPilot.Date(end.getDatePart());
        //console.log("date=",dateClean, "start=",startClean, "end=", endClean, "isDayPilotDateInBetween=",res);
        return startClean <= dateClean && dateClean <= endClean;
    }

    constructor(props: SchedulerProps) {
        super(props);
        this._format = Helper.isNullOrEmpty(props.settings.DateFormatAtMoving) ? Helper.getLocalDateformat() : props.settings.DateFormatAtMoving;
        this._setColumnTemplate();
        this.state = {
            capacityIsOn: false
        }
    }

    private _setColumnTemplate = () => {
        if (!Config.user.useTemplateInResourcePlanning || Helper.isNullOrEmpty(this.props.columnTemplate)) return;
        try {
            this.columnTemplate = kendo.template(this.props.columnTemplate)
        } catch { }
    }

    private _init = () => {
        this._dps = new DayPilot.Scheduler(this._dayPilotDiv);
        window["dps"] = this._dps;

        window.addEventListener("keydown", function (ev) {
            if (ev.key === "Escape") {
                DayPilot.Scheduler.stopDragging();
                ev.preventDefault();
                ev.stopPropagation();
            }
        });


        this.resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            /* Die Breite des Element was vom ResizeObserver beaobachetet wird, wird zeitweise auf 0 gesetzt. 
               Ich weiß nicht ob das durch unseren Source oder durch den Scheduler passiert... 
               Jedenfalls bekommt es danach die orginalle Breite zurück
               Ich weiß das der Fix ist nicht schön aber mir fällt gerade nichts besseres ein
               Als Entschädigung empfehle ich, sich 'Violator' von Depoche Mode anzuhören
             */
            if (width != 0) {
                const display = (width > 180) ? "flex" : "none"
                document.querySelectorAll("div[data-role='profile_picture_wrapper']").forEach((wrapper: any) => {
                    wrapper.style.display = display;
                });
            }
        });

        let v = this._dps;
        // Dynamic settings
        this._initDynamicSettings(v, true);

        this._trAirLine = this.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.Airline"];
        this._trThere = Helper.getTranslation("WebSMS.ServiceReport.Hinreise");
        this._trBack = Helper.getTranslation("WebSMS.ServiceReport.Rückreise");
        this._trKm = this.props.translations["GeoMap.Km"];
        this._freeSlot = this.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.FreeSlot"];

        // Events
        v.onAfterUpdate = this._onAfterUpdate;
        v.onBeforeResHeaderRender = this._onBeforeResHeaderRender;
        v.onBeforeEventRender = this._onBeforeEventRender;
        v.onAfterEventRender = this._afterEventRender;
        v.onBeforeCellRender = this._onBeforeCellRender;
        v.onBeforeTimeHeaderRender = this._onBeforeTimeHeaderRender;
        v.onBeforeRowHeaderRender = this._onBeforeRowHeaderRender;
        v.onEventClick = (args) => {
            this._dayPilotDiv.focus();
            if (!this._dps.allowMultiSelect) {
                const slotData = this._getSlotById(args.e.data.id, args.e.data.resource);
                if (slotData) {
                    this.markEvent(args.e.id(), slotData);
                } else {
                    if (this.getEventById(args.e.data.id).IsAnnonymous) {
                        args.preventDefault();
                    } else {
                        this.markEvent(args.e.id());
                    }
                }
            }
        };

        v.onEventDoubleClick = (args) => {
            this.props.actions.openEvent(args.e.data.id, args.e.data.resource);
        };

        v.onEventSelected = () => {
            if (this.props.multiSelectActive) {
                let dpsEvents = this._dps.multiselect.events();
                let lst = this._data.Events.filter(f1 => dpsEvents.findIndex(f2 => f2.id() == f1.Id) > -1)
                this.props.actions.multiSelectEventsSelected(lst);
            }
        }

        v.onRectangleSelect = (args: DayPilot.SchedulerRectangleSelectArgs) => {
            args.append = true;
        }

        v.onRectangleSelected = () => {
            if (this.props.multiSelectActive) {
                let dpsEvents = this._dps.multiselect.events();
                let lst = this._data.Events.filter(f1 => dpsEvents.findIndex(f2 => f2.id() == f1.Id) > -1)
                this.props.actions.multiSelectEventsSelected(lst);
            }
        }

        v.onEventSelect = (args) => {
            if (this.getEventById(args.e.data.id).IsAnnonymous) {
                args.preventDefault();
            } else if (!this._dps.allowMultiSelect) {
                this.markEvent(args.e.id());
            }
        };
        v.onEventMove = async (args) => {
            let resource = args.e.resource();
            if (!this.props.settings.AssignmentMoveHorizontalFixed) {
                resource = args.newResource;
            }
            await this._handleEventMove(args.e, args.newStart, args.newEnd, resource, args.external, args.ctrl, args.shift, false);
        };

        v.onEventResizing = async (_arg : DayPilot.SchedulerEventResizingArgs) => {
            //first => set focus
            this._dayPilotDiv.focus();
        }
        v.onEventResize = async (args) => {
            await this._handleEventMove(args.e, args.newStart, args.newEnd, args.e.resource(), false, false, false, true);
        };

        v.onEventMoving = (args) => {
            this._dayPilotDiv.focus();
            
            let di: ResourcePlanningSchedulerEventViewModel = this.getEventById(args.e.data.id);
            let resStart: ResourcePlanningSchedulerResourceViewModel = this.getResourceById(args.e.resource());
            let resEnd: ResourcePlanningSchedulerResourceViewModel = this.getResourceById(args.resource);


            if (!di) {
                return;
            }

            if (Helper.hasValue(resStart) && (!resStart.CanWrite || !resEnd.CanWrite)) {
                args.right.enabled = true;
                args.right.html = this.props.translations["Rechte.UnzureichendeBerechtigungenAnContainerRessource"];
                args.allowed = false;
                return;
            }

            if (this.props.settings.AssignmentMoveHorizontalFixed) {
                if (this.props.settings.GroupByResources)
                    args.resource = di.ResourceId
                else if (this.props.settings.GroupByAddresses)
                    args.resource = di.AdrNr;
                else if (this.props.settings.GroupByProjects)
                    args.resource = di.Projnr;
                else if (this.props.settings.GroupByMachines)
                    args.resource = di.MaschNr
            }

            if (this.props.settings.AssignmentMoveVerticalFixed || di.FixStart == 1 || di.FixEnd == 1) {
                args.start = args.e.start();
                args.end = args.e.end();
            }
        }
        v.onRowSelected = this._handleRowSelected;
        v.onRowDoubleClick = this._handleResourceDoubleClick;
        v.onRowHeaderColumnResized = this._updateCapacityDiagramLegendWidth;
        v.onRowFilter = this._handleRowFilter;
        v.onTimeHeaderClicked = this._handleTimeHeaderClicked;
        v.onAfterRender = async () => {
            // console.log("onAfterRender")
            // await Helper.setBusyIndicator(false);
        };
        v.onDimensionsChanged = () => {
            if (this._capacityDiagram) {
                this._capacityDiagram.updateCellWidth();
            }
        }
        v.onTimeRangeSelected = (args) => {
            this._dayPilotDiv.focus();
            
            if (this.props.selectedTimeRangeChanged)
                this.props.selectedTimeRangeChanged(args.resource, args.start.toDate());

            if (this._ctrlPressed) {
                this._ctrlPressed = false;
                this._handleSchedulerSelectionContextMenuClick("new", args as any);
            } else {
                //manchmal wird "keyup" nicht getriggered
                this._ctrlPressed = false;
            }
        }
        v.onTimeRangeSelecting = (args: DayPilot.SchedulerTimeRangeSelectingArgs) => {
            this._schedulerTimeRangeSelectingArgs = {...args};
            args.left.html = kendo.toString(args.start.toDateLocal(), v.timeRangeSelectingStartEndFormat);
            // Fix: Beim Auswählen der Zellen wird als Enddatum +1 Tag angezeigt (Daypilot Standard)
            args.right.html = kendo.toString(Helper.dates.addSeconds(args.end.toDateLocal(), -1), v.timeRangeSelectingStartEndFormat)
        }

        let businessEndHour = parseInt(this._data.CapacitySettings.BusinessEndsTime.substring(0, 2), 10);
        const businessEndMinutes = parseInt(this._data.CapacitySettings.BusinessEndsTime.substring(3, 5), 10);
        if (businessEndMinutes > 0) {
            businessEndHour++;
        }

        // Static settings
        v.allowEventOverlap = true;
        v.allowMultiMove = false;
        v.allowMultiRange = false;
        v.allowMultiResize = false;
        v.autoRefreshCommand = 'refresh';
        v.autoRefreshEnabled = false;
        v.autoRefreshInterval = 60;
        v.autoRefreshMaxCount = 20;
        v.autoScroll = 'Drag';
        v.blockOnCallBack = false;
        v.businessBeginsHour = +this._data.CapacitySettings.BusinessStartsTime.substring(0, 2) - this._data.CapacitySettings.BusinessTimeExpandViewByXHours;
        v.businessEndsHour = businessEndHour + this._data.CapacitySettings.BusinessTimeExpandViewByXHours;
        v.businessWeekends = false;
        v.cellDuration = 60;
        v.cellGroupBy = 'Day';
        v.cellSweeping = true;
        v.cellSweepingCacheSize = 1000;
        v.cellWidthMin = 1;
        v.cellWidthSpec = this.props.settings.FixedCellWidth ? 'Fixed' : "Auto";
        v.crosshairType = 'Header';
        v.theme = 'scheduler_white';
        v.dragOutAllowed = false;
        v.drawBlankCells = true;
        v.durationBarHeight = 3;
        v.durationBarMode = 'PercentComplete';
        v.dynamicEventRenderingMargin = 50;
        v.dynamicEventRenderingCacheSize = 200;
        v.dynamicEventRenderingCacheSweeping = false;
        v.dynamicLoading = false;
        v.eventEndSpec = 'DateTime';
        v.eventHeight = 24 + ((this.props.settings.NumberOfLinesInEvent - 1) * 15);


        v.eventMoveMargin = 5;
        v.eventMoveSkipNonBusiness = false;

        v.eventStackingLineHeight = this.props.settings.Overlapping;

        v.eventMovingStartEndEnabled = this.props.settings.AdditionalDatesAtMove;
        v.eventMovingStartEndFormat = this._format;

        v.eventResizingStartEndEnabled = this.props.settings.AdditionalDatesAtMove;
        v.eventResizingStartEndFormat = this._format;

        v.timeRangeSelectingStartEndEnabled = this.props.settings.AdditionalDatesAtMove;
        v.timeRangeSelectingStartEndFormat = this._format;

        v.eventMoveToPosition = false;
        v.eventResizeMargin = 5;
        v.floatingEvents = false;
        v.floatingTimeHeaders = false;
        v.groupConcurrentEvents = false;
        v.groupConcurrentEventsLimit = 1;
        v.headerHeight = 20;
        v.height = 0;
        v.heightSpec = 'Parent100Pct';
        v.hideBorderFor100PctHeight = false;
        v.hideUntilInit = false;
        v.linkBottomMargin = 12;
        v.loadingLabelText = '';
        v.loadingLabelVisible = true;
        v.messageBarPosition = 'Top';
        v.messageHideAfter = 5000;
        v.messageHideOnMouseOut = true;
        v.moveBy = 'Full';
        v.notifyCommit = 'Immediate';
        v.snapToGrid = true;
        v.snapToGridTimeRangeSelecting = true;
        v.snapToGridEventMoving = false;
        v.snapToGridEventResizing = false;
        v.progressiveRowRendering = true;
        v.progressiveRowRenderingPreload = 25;
        v.rowMinHeight = 0;
        v.rowHeaderHideIconEnabled = false;
        v.rowHeaderScrolling = false;
        v.rowHeaderWidth = 80;
        v.rowHeaderWidthAutoFit = false;
        v.scrollDelayDynamic = 0;
        v.scrollDelayCells = 0;
        v.scrollDelayEvents = 0;
        v.scrollDelayFloats = 0;
        v.showToolTip = true;
        v.syncResourceTree = true;
        v.tapAndHoldTimeout = 500;
        v.timeFormat = 'Auto';
        v.treeEnabled = false;
        v.treeIndent = 20;
        v.treeImageMarginLeft = 5;
        v.treeImageMarginTop = 5;
        v.treePreventParentUsage = false;
        v.viewType = 'Resources';
        v.resourceBubble = null;
        v.eventDeleteHandling = 'Disabled';
        v.eventDoubleClickHandling = 'Enabled';
        v.rowClickHandling = 'Select';
        v.rowCreateHandling = 'Disabled';
        v.rowDoubleClickHandling = 'Enabled';
        v.rowMoveHandling = 'Disabled';
        v.timeRangeDoubleClickHandling = 'Disabled';
        v.separators = [];
        v.links.list = null;
        v.sortDirections = this.props.settings.AssignmentSorting.map(item => item.Order);
        v.rowHeaderColumnsMode = "Legacy";
        v.rectangleSelectMode = "Free";
        if (Helper.hasValue(this.props.settings.HeightOfResourceInfo)) {
            v.rowMinHeight = this.props.settings.HeightOfResourceInfo;
        }

        v.onRowClicked = (args: DayPilot.SchedulerRowClickedArgs) => {
            const id = (args as any).resource.data.id;
            this._data.SettingsPlanningBoard.RowHeaderColumns.forEach(h => {
                let el = document.getElementById(`EP_${h.Title}_${id}`);
                if (Helper.hasValue(el)) {
                    el.style.background = null;
                    el.style.color = "#000000";
                }
            });
        }

        // Menu
        this._resourceContextMenu = new DayPilot.Menu({
            items: [],
            onShow: (args) => {
                this._reloadResourceContextMenu(args.source.data.id);
                if (this._resourceContextMenu.items.length === 0) {
                    args.preventDefault();
                }
            }
        });
        v.contextMenuResource = this._resourceContextMenu;
        this._eventContextMenu = new DayPilot.Menu({
            items: [],
            onShow: async (args) => {
                await this._reloadEventContextMenu(args.source);
                if (this._eventContextMenu.items.length === 0) {
                    args.preventDefault();
                } else if (!this._dps.allowMultiSelect) {
                    this.markEvent(args.source.id());
                }
            }
        });
        v.contextMenu = this._eventContextMenu;
        this._selectionContextMenu = new DayPilot.Menu({
            items: [],
            onShow: (args) => {
                this._reloadSelectionContextMenu(args);
                if (this._selectionContextMenu.items.length === 0) {
                    args.preventDefault();
                }
            }
        });
        v.contextMenuSelection = this._selectionContextMenu;
        v.onRowHeaderColumnResized = this._onRowHeaderColumnResized;
        v.onAfterCellRender = this.registerDragDropEvents;
        //v.separators = [{ color: "#FF66CC", location: "2019-11-29T00:00:00", layer: "AboveEvents", width: 10 }];


        v.init();
    }


    private _onRowHeaderColumnResized = (event: { column: { title: string, width: number } }) => {
        Helper.saveDataToStorage(`FSM_Scheduler_${Config.user.userName}_Column_Width_${event.column.title.toLowerCase()}`, event.column.width, false);
    }

    private _reloadEventContextMenu = async (event: DayPilot.Event) => {
        //clear all
        this._eventContextMenu.items.length = 0;
        const eventData = this.getEventById(event.id());
        const slotData = this._getSlotById(event.id(), event.resource());

        if (eventData && eventData.AllowContextMenu) {
            if (this.props.multiSelectActive) {
                this._setMultiselectContextMenu(event);
            } else {
                this._setDefaultContextMenu(event);
            }
        }

        if (slotData) {
            if (Helper.hasValue(this.props.slotModeSourceId)) {
                this._eventContextMenu.items.push({
                    text: this.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.UseSlot"],
                    onClick: (args) => {
                        const slotEvent = args.source as DayPilot.Event;
                        this._handleSchedulerEventContextMenuClick("useSlot", slotEvent);
                    }
                });
            }
        }

    }

    private _setMultiselectContextMenu = (event: DayPilot.Event) => {
        const gtlast = this.props.translations["WebSMS.ResourcePlaningGrouping.SelectLast"];
        let last = Helper.loadDataFromStorage("AssignentGroupingLastNew", BrowserStorageType.Session);
        if (last === undefined)
            last = 0;

        const eventData = this.getEventById(event.id());
        //Mit der Bedingung wird geprüft ob das Event, was angeklickt worden ist, in der Liste der selektierten Events drin ist
        if (this._dps.multiselect.events().findIndex(f => f.id() == event.id()) > -1) {
            const createHTML = (title: string, iconName: string = null) => {
                const iTag = Helper.isNullOrEmpty(iconName) ? "" : `<i class='fal fa-${iconName}' style='margin-right: 8px'></i>`
                return `<div style='border-top: 0; margin: 0;${Helper.isNullOrEmpty(iconName) ? "margin-left: 20px;" : ""}'>${iTag}${title}</div>`
            }
            this._eventContextMenu.items = [
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.DeleteSelectedAssignments"], "trash-alt"),
                    onClick: () => {
                        this.props.actions.executeMultiSelectAction(MultiSelectAction.Delete)
                    }
                },
                { text: "-" },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.GroupSelectedAssignments"], "layer-group"),
                    items: [
                        {
                            html: this.props.translations["WebSMS.ResourcePlanning.GroupingNew"],
                            onClick: () => {
                                this.props.actions.processAssigmentGroupingList(MultiSelectAction.New);
                            },
                        },
                        {
                            html: gtlast.replace('{last}', last.toString()),
                            onClick: () => {
                                this.props.actions.processAssigmentGroupingList(MultiSelectAction.ChangeLast);
                            },
                            hidden: last == 0
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanning.GroupingSelect"],
                            onClick: () => {
                                this.props.actions.processAssigmentGroupingList(MultiSelectAction.Change);
                            },
                        }
                    ]
                },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UngroupSelectedAssignments"]),
                    onClick: () => {
                        this.props.actions.processAssigmentGroupingList(MultiSelectAction.Delete);
                    }
                },
                { text: "-" },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SelectedToContainer"]),
                    onClick: () => {
                        this.props.actions.executeMultiSelectAction(MultiSelectAction.MoveToContainer)
                    }
                },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.AssignToRessource"], "person"),
                    onClick: () => {
                        this.props.actions.executeMultiSelectAction(MultiSelectAction.MoveToResource)
                    }
                },
                { text: "-" },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.FilterProjects"], "folder"),
                    onClick: () => {
                        this.props.actions.executeMultiSelectAction(MultiSelectAction.FilterProjects)
                    }
                },
                { text: "-" },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations"], "lock-open"),
                    items: [
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixStart"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("fix", FixMode.Start)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixEnd"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("fix", FixMode.End)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixRessource"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("fix", FixMode.Ressource)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixSE"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("fix", FixMode.Start | FixMode.End)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixAll"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("fix", FixMode.Start | FixMode.End | FixMode.Ressource)
                            }
                        },
                    ]
                },
                {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation"], "lock"),
                    items: [
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.Start"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("defix", FixMode.Start)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.End"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("defix", FixMode.End)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.Resource"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("defix", FixMode.Ressource)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.SE"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("defix", FixMode.Start | FixMode.End)
                            }
                        },
                        {
                            html: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.All"],
                            onClick: () => {
                                this.props.actions.executeMultiSelectFixing("defix", FixMode.Start | FixMode.End | FixMode.Ressource)
                            }
                        },
                    ]
                },
                {
                    text: "-",
                    hidden: !eventData.ResourceId.startsWith('r|')
                },
                {
                    html: createHTML(Helper.getTranslation("Field.Einsatz.ChangeTransmissionState"), "paper-plane"),
                    onClick: async () => {
                        try {
                            const newSendState = await OpenStatusSendDialog();
                            this.props.actions.changeStatusSend(newSendState);
                        } catch {

                        }
                    },
                    hidden: !eventData.ResourceId.startsWith('r|')
                }
            ];

            if (!this.props.settings.AssignmentGroupingActive)
                this._eventContextMenu.items.splice(1, 3);

            const renderFlagContextmenu = Config.settings.flagsAreActive && this.props.settings.GroupByResources
                && this.props.settings.TimeResolutionType == this._timeResolutionTypes.Days && this.props.settings.FlagMode > 0
                && !this.props.settings.ReadOnlyScheduler /*&& !this.props.slotModeActive*/;
            if (renderFlagContextmenu) {
                const menuItem: DayPilot.MenuItemData = {
                    html: createHTML(this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.Flags"], "flag"),
                    items: []
                }
                this.props.settings.Flags.forEach((flag) => {
                    menuItem.items.push({
                        text: flag.Name,
                        onClick: () => {
                            const ids = this._data.Events
                                .filter(f1 => this._dps.multiselect.events().findIndex(f2 => f2.id() == f1.Id) > -1)
                                .map(event => {
                                    return event.IsGuid
                                })
                            if (Helper.hasValue(ids)) {
                                this.props.actions.addFlagToAssignments(flag.Id, ids);
                            }
                        }
                    });
                });
                if (menuItem.items.length > 0)
                    menuItem.items.push({ text: "-" });
                menuItem.items.push({
                    text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.RemoveFlags"],
                    onClick: () => {
                        const ids = this._data.Events
                            .filter(f1 => this._dps.multiselect.events().findIndex(f2 => f2.id() == f1.Id) > -1)
                            .map(event => {
                                return event.IsGuid
                            })
                        if (Helper.hasValue(ids)) {
                            this.props.actions.removeFlagsFromAssignments(ids);
                        }
                    }
                });
                if (Config.user.isSysAdmin) {
                    menuItem.items.push({ text: "-" });
                    menuItem.items.push({
                        text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.NewFlag"],
                        onClick: () => {
                            const ids = this._data.Events
                                .filter(f1 => this._dps.multiselect.events().findIndex(f2 => f2.id() == f1.Id) > -1)
                                .map(event => {
                                    return event.IsGuid
                                })
                            if (Helper.hasValue(ids)) {
                                const sheet = General.Sheet.Manager.createSheetWithUrl("PlanningBoardFlag/Edit?closeAfterSave=true");
                                sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: any }) => {
                                    this.props.actions.addFlagToAssignments(data.entity.Id, ids);

                                });
                            }
                        }
                    });
                }
                this._eventContextMenu.items.push({ text: "-" });
                this._eventContextMenu.items.push(menuItem);
            }
        }
    }

    private _setDefaultContextMenu = (event: DayPilot.Event) => {
        const eventData = this.getEventById(event.id());
        const isAbsence = eventData.KennungTyp == Kennungstyp.Urlaub || eventData.KennungTyp == Kennungstyp.Fehlzeit;

        let groupping = 0;

        if (Helper.hasValue(eventData) && Helper.hasValue(eventData.Gruppierung)) {
            groupping = eventData.Gruppierung;
        }

        let isContainer = false;
        if (Helper.hasValue(eventData)) {
            isContainer = !eventData.ResourceId.startsWith('r|');
        }


        let last = Helper.loadDataFromStorage("AssignentGroupingLastNew", BrowserStorageType.Session);
        if (last === undefined)
            last = 0;

        const gr = this.props.translations["WebSMS.ResourcePlaningGrouping.GroppedAssigments"];
        const gtlast = this.props.translations["WebSMS.ResourcePlaningGrouping.SelectLast"];

        let connectedToCompletedSAP: boolean = false;
        if (Helper.hasValue(eventData) && Helper.hasValue(eventData.ProjectStatus)) {
            connectedToCompletedSAP = Helper.getValueOrDefault(eventData.ProjectStatus.Planung, 0) == 2;
        }

        let canWrite: boolean = false;
        if (Helper.hasValue(eventData) && Helper.hasValue(eventData.RecordRight)) {
            canWrite = Helper.getValueOrDefault(eventData.RecordRight.CanWrite, false);
        }

        if (!eventData.IsAnnonymous) {
            const eventIsEditable = !connectedToCompletedSAP && !this.props.settings.ReadOnlyScheduler;
            this._eventContextMenu.items.push({
                text: this.props.translations["Standard.Öffnen"],
                onClick: (args) => {
                    const e = args.source;
                    this._handleSchedulerEventContextMenuClick("open", e);
                }
            });

            const splitter = {
                text: "-"
            }

            const showBackToContainer = !this.props.settings.ReadOnlyScheduler
                && eventData.KennungTyp !== Kennungstyp.Urlaub
                && eventData.KennungTyp !== Kennungstyp.Fehlzeit
                && !isContainer
                && Helper.hasValue(eventData.GrNr);

            if (eventIsEditable || showBackToContainer) {
                const item: DayPilot.MenuItemData = {
                    text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.Change"),
                    items: [],
                    disabled: !canWrite
                }

                let showSplitter = false;
                if (showBackToContainer && !eventData.FixResource) {
                    showSplitter = true;
                    item.items.push({
                        text: Helper.getTranslation("WebSMS.ResourcePlanning.MoveToContainer"),
                        onClick: () => {
                            this.props.actions.moveEvent(eventData.Id, Helper.dates.toDate(eventData.Start), Helper.dates.toDate(eventData.End), `g|${eventData.GrNr}`, eventData.ResourceId, false, false);
                        }
                    });
                }

                if (eventIsEditable) {

                    if (!eventData.FixStart && !eventData.FixEnd) {
                        showSplitter = true;
                        item.items.push({
                            text: Helper.getTranslation("Einsatz.ChangeStartTime"),
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuClick("changeStartTime", e);
                            }
                        });
                    }


                    if (!isAbsence && !eventData.FixEnd) {
                        showSplitter = true;
                        item.items.push({
                            text: this.props.translations["WebSMS.ResourcePlanning.FitToWorkingTime"],
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuClick("fitToWorkingTime", e);
                            }
                        });
                    }

                    if (isContainer || eventData.FixResource == 0) {
                        showSplitter = true;
                        item.items.push({
                            text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.AssignResourc"),
                            onClick: async () => {

                                const result = await ResourcePlanningHelper.openResourceSearch({
                                    grnr: eventData.GrNr,
                                    resstatus: "0 or null",
                                    disabled: "resstatus"
                                });
                                const ressNr = Helper.getAttributeSavely(result, "ressnr")
                                this.props.actions.moveEvent(eventData.Id, Helper.dates.toDate(eventData.Start), Helper.dates.toDate(eventData.End), `r|${ressNr}`, eventData.ResourceId, false, false);
                            }
                        });
                    }


                    if (showSplitter)
                        item.items.push(splitter);


                    item.items.push({
                        text: Helper.getTranslation("Field.Einsatz.fixiertstart"),
                        onClick: () => {
                            this.props.actions.toggleFixedStart(eventData);
                        },
                        icon: eventData.FixStart == 1 ? "fa-light fa-check" : ""
                    });


                    item.items.push({
                        text: Helper.getTranslation("Field.Einsatz.fixiertende"),
                        onClick: () => {
                            this.props.actions.toggleFixedEnd(eventData);
                        },
                        icon: eventData.FixEnd == 1 ? "fa-light fa-check" : ""
                    });

                    if (!isContainer) {
                        item.items.push({
                            text: Helper.getTranslation("Field.Einsatz.fixiertressource"),
                            onClick: () => {
                                this.props.actions.toggleFixedResource(eventData);
                            },
                            icon: eventData.FixResource == 1 ? "fa-light fa-check" : ""
                        });
                    }


                    item.items.push(splitter);

                    item.items.push({
                        text: Helper.getTranslation("Field.Einsatz.geplant"),
                        onClick: () => {
                            this.props.actions.toggleProvisional(eventData);
                        },
                        icon: eventData.Provisional ? "fa-light fa-check" : ""
                    });

                    if (eventData.KennungTyp == Kennungstyp.Urlaub) {
                        item.items.push({
                            text: Helper.getTranslation("Field.Einsatz.halbertag"),
                            onClick: () => {
                                this.props.actions.toggleHalfDay(eventData);
                            },
                            icon: eventData.IsHalfDay ? "fa-light fa-check" : ""
                        });
                    }

                    if (!isContainer) {
                        item.items.push(splitter);
                        item.items.push({
                            text: Helper.getTranslation("Field.Einsatz.ChangeTransmissionState"),
                            items: this.props.settings.SendStates.map((item: SendStateInfo) => {
                                const icon = Helper.isNullOrEmpty(item.IconCode) ?
                                    `<span style="grid-column: 2/3;"></span>` :
                                    `<span style="grid-column: 2/3; color: ${item.IconColor}">&#x${item.IconCode}</span>`;
                                return {
                                    html: `<div style='border-top: 0; margin: 0; display: grid; grid-template-columns: 80px auto'>
                                                <span style="grid-column: 1/2">
                                                    ${item.Name}
                                                </span>
                                                ${icon}                
                                            </div>`,
                                    onClick: () => {
                                        this.props.actions.changeSendState(eventData, item.Id)
                                    },
                                    icon: eventData.SendStatus == item.Id ? "fa-light fa-check" : "",
                                    disabled: Config.user.restrictSendState && (item.Id != 0 && item.Id != 1)
                                }
                            })
                        });
                    }
                }
                this._eventContextMenu.items.push(item);
            }



            if (eventIsEditable) {
                this._eventContextMenu.items.push({
                    text: this.props.translations["Standard.Loeschen"],
                    onClick: (args) => {
                        const e = args.source;
                        this._handleSchedulerEventContextMenuClick("delete", e);
                    },
                    disabled: !canWrite
                });
            }


            if (eventIsEditable) {
                this._eventContextMenu.items.push(splitter);
                this._eventContextMenu.items.push({
                    text: this.props.translations["Standard.Kopieren"],
                    items: [{
                        text: this.props.translations["Standard.Kopieren"],
                        onClick: (args) => {
                            this._handleSchedulerEventContextMenuClick("copy", args.source);
                        }
                    }, {
                        text: this.props.translations["Einsatz.CopyToResources"],
                        onClick: (args) => {
                            this._handleSchedulerEventContextMenuClick("copyToResources", args.source);
                        }
                    }],
                    disabled: !canWrite
                });


                if (!isAbsence) {
                    this._eventContextMenu.items.push({
                        text: this.props.translations["Standard.Split"],
                        items: [{
                            text: this.props.translations["Standard.Split"],
                            onClick: (args) => {
                                this._handleSchedulerEventContextMenuClick("split", args.source);
                            }
                        }, {
                            text: this.props.translations["Einsatz.SplitToResources"],
                            onClick: (args) => {
                                this._handleSchedulerEventContextMenuClick("splitToResources", args.source);
                            }
                        }],
                        disabled: !canWrite
                    });
                }

                if (!isContainer && this.props.settings.GroupByResources) {
                    this._eventContextMenu.items.push({
                        text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.SplitAssignment"),
                        onClick: async (args) => {
                            const data = args.source.data;
                            const [projNr, pIndex] = data.id.split('|');
                            const start: string | Date = data.start;
                            const result = await SplittingDialogUtil.openSplittingWindow(projNr, pIndex, start, this.markEvent);
                            switch (result) {
                                case SplittingDialogResult.Success:
                                    this.props.actions.doRefresh();
                                    break;
                                case SplittingDialogResult.NoAssignments:
                                    NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.NoAssignments"));
                                    break;
                            }
                        },
                        disabled: !canWrite
                    });
                }

                if (!isAbsence && !isContainer && this.props.settings.Geomap_Enabled) {
                    this._eventContextMenu.items.push({
                        text: Helper.getTranslation("Einsatz.journey"),
                        items: [{
                            text: this.props.translations["GeoMap.Routenplanung"],
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuClick("calculateRoute", e);
                            }
                        }, {
                            text: this.props.translations["GeoMap.CalculateTravelTimes"],
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuClick("calculateTravelTimes", e);
                            },
                            disabled: !canWrite
                        }]
                    });
                }
            }


            const renderFlagContextmenu = Config.settings.flagsAreActive && this.props.settings.GroupByResources
                && this.props.settings.TimeResolutionType == this._timeResolutionTypes.Days && this.props.settings.FlagMode > 0
                && !this.props.settings.ReadOnlyScheduler;
            if (renderFlagContextmenu) {
                this._eventContextMenu.items.push(splitter);
                const menuItem: DayPilot.MenuItemData = {
                    text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.Flags"],
                    items: [],
                    disabled: !canWrite
                }
                this.props.settings.Flags.forEach((flag) => {
                    menuItem.items.push({
                        text: flag.Name,
                        onClick: (e) => {
                            const id = e.source.data.id;
                            const event = this._data.Events.find(f => f.Id == id);
                            if (Helper.hasValue(event) && !Helper.isNullOrEmpty(event.IsGuid)) {
                                this.props.actions.addFlagToAssignments(flag.Id, [event.IsGuid]);
                            }
                        },
                        icon: eventData.FlagId == flag.Id ? "fa-light fa-check" : ""
                    });
                });
                if (menuItem.items.length > 0)
                    menuItem.items.push(splitter);
                menuItem.items.push({
                    text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.RemoveFlags"],
                    onClick: (e) => {
                        const id = e.source.data.id;
                        const event = this.getEventById(id);
                        if (Helper.hasValue(event) && !Helper.isNullOrEmpty(event.IsGuid)) {
                            this.props.actions.removeFlagsFromAssignments([event.IsGuid]);
                        }
                    }
                });
                if (Config.user.isSysAdmin) {
                    menuItem.items.push(splitter);
                    menuItem.items.push({
                        text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.NewFlag"],
                        onClick: (e) => {
                            const id = e.source.data.id;
                            const event = this.getEventById(id);
                            if (Helper.hasValue(event) && !Helper.isNullOrEmpty(event.IsGuid)) {
                                const sheet = General.Sheet.Manager.createSheetWithUrl("PlanningBoardFlag/Edit?closeAfterSave=true");
                                sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: any }) => {
                                    this.props.actions.addFlagToAssignments(data.entity.Id, [event.IsGuid]);

                                });
                            }
                        }
                    });
                }
                this._eventContextMenu.items.push(menuItem);
            }
            if (eventIsEditable) {
                this._eventContextMenu.items.push(splitter);
                this._eventContextMenu.items.push({
                    text: groupping == 0
                        ? gr
                        : gr +
                        ', ' +
                        this.props.translations["WebSMS.ResourcePlaningGrouping.Grouping"] +
                        ' - ' +
                        groupping,
                    disabled: groupping == 0 && !canWrite,
                    items: [
                        {
                            text: this.props.translations["WebSMS.ResourcePlanning.GroupingNew"],
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuGrouppingClick("new", e);
                            },
                            disabled: !canWrite
                        },
                        {
                            text: gtlast.replace('{last}', last.toString()),
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuGrouppingClick("last", e, last);
                            },
                            hidden: last == 0,
                            disabled: !canWrite
                        },
                        {
                            text: this.props.translations["WebSMS.ResourcePlanning.GroupingSelect"],
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuGrouppingClick("change", e);
                            },
                            disabled: !canWrite
                        },
                        {
                            text: this.props.translations["WebSMS.ResourcePlanning.GroupingDelete"],
                            hidden: groupping == 0,
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuGrouppingClick("delete", e);
                            },
                            disabled: !canWrite
                        },
                        {
                            text: this.props.translations["WebSMS.ResourcePlanning.GroupingShow"],
                            hidden: groupping == 0,
                            onClick: (args) => {
                                const e = args.source;
                                this._handleSchedulerEventContextMenuGrouppingClick("list", e);
                            }
                        }
                    ]
                });
            }


            this._eventContextMenu.items.push(splitter);
            if(Config.user.activeExtendedProjectFilter){
                this._eventContextMenu.items.push({
                    text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.Filter"),
                    items: [{
                        text: Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.AddProjectToFilter"),
                        onClick: (args) => {
                            const source = args.source;
                            if (Helper.hasValue(source)) {
                                const id: string = source.id();
                                const projNr = id.split("|")[0];
                                this.props.actions.addProjNr(projNr);
                            }
                        }
                    }]
                });
            }else{
                this._eventContextMenu.items.push({
                    text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.Filter"),
                    items: [{
                        text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.Filter.FilterProjects"),
                        onClick: (args) => {
                            const source = args.source;
                            if (Helper.hasValue(source)) {
                                const id: string = source.id();
                                const projNr = id.split("|")[0];
                                this.props.actions.filterByProjNr(projNr);
                            }
                        }
                    }]
                });
            }
        }
    }

    private _reloadResourceContextMenu = (resourceId: string) => {
        const showOpenResource = resourceId.indexOf('r') !== -1;
        const resource = this.getResourceById(resourceId);
        //console.log(resource)

        //clear all
        this._resourceContextMenu.items.length = 0;

        if (this.props.settings.GroupByResources) {
            if (!this.props.settings.ReadOnlyScheduler /*&& !this.props.slotModeActive*/ && this.props.settings.GroupByResources) {
                this._resourceContextMenu.items.push({
                    text: this.props.translations["Einsatz.NeuenEinsatzAnlegen"],
                    onClick: (args) => {
                        const e = args.source;
                        this._handleResourceContextMenuClick("new", e);
                    }
                });

                if (this.props.settings.CreateAssignmentWithPM_Enabled) {
                    this._resourceContextMenu.items.push({
                        text: this.props.translations["Einsatz.NeuenEinsatzAnlegenPM"],
                        onClick: (args) => {
                            const e = args.source;
                            this._handleResourceContextMenuClick("newPM", e);
                        }
                    });
                }
            }

        } else if (this.props.settings.GroupByProjects) {
            this._resourceContextMenu.items.push({
                text: Helper.getTranslation("BrowserTitle.Project.Open"),
                onClick: (args) => {
                    const projNr = args.source.data.id;
                    this.props.actions.openProject(projNr);
                }
            });
        }

        if (showOpenResource) {
            this._resourceContextMenu.items.push({
                text: this.props.translations["Ressource.Öffnen"],
                onClick: (args) => {
                    const e = args.source;
                    this._handleResourceContextMenuClick("open", e);
                }
            });
        }

        if (resource != null) {
            const teamsMail: string = resource["TeamsMail"];
            if (!Helper.isNullOrEmpty(teamsMail) && resourceId != `r|${Config.user.ressNr}`) {
                const open = (url: string) => {
                    window.open(url);
                }


                this._resourceContextMenu.items.push({
                    text: Helper.getTranslation("MST.Scheduler.Teams"),
                    items: [
                        {
                            text: Helper.getTranslation("MST.Scheduler.OpenChat"),
                            onClick: () => {
                                open(`https://teams.microsoft.com/l/chat/0/0?users=${teamsMail}`);
                            }
                        },
                        {
                            text: Helper.getTranslation("MST.Scheduler.StartCall"),
                            onClick: () => {
                                open(`https://teams.microsoft.com/l/call/0/0?users=${teamsMail}`);
                            }
                        }
                    ]
                });
            }
        }
    }

    private _reloadSelectionContextMenu = (args: DayPilot.MenuShowArgs) => {
        //clear all
        this._selectionContextMenu.items.length = 0;

        if (!this.props.settings.ReadOnlyScheduler /*&& !this.props.slotModeActive*/) {
            this._selectionContextMenu.items.push({
                text: this.props.translations["Einsatz.NeuenEinsatzAnlegen"],
                onClick: (args) => {
                    const e = args.source;
                    this._handleSchedulerSelectionContextMenuClick("new", e);
                }
            });

            if (this.props.settings.CreateAssignmentWithPM_Enabled) {
                this._selectionContextMenu.items.push({
                    text: this.props.translations["Einsatz.NeuenEinsatzAnlegenPM"],
                    onClick: (args) => {
                        const e = args.source;
                        this._handleSchedulerSelectionContextMenuClick("newPM", e);
                    }
                });
            }

            if (Helper.hasValue(this._currentlySelectedEventId) && this.props.settings.GroupByResources) {
                this._selectionContextMenu.items.push({
                    text: this.props.translations["Einsatz.AusgewählterEinsatzKopieren"],
                    onClick: (args) => {
                        const e = args.source;
                        this._handleSchedulerSelectionContextMenuClick("copySelected", e);
                    }
                });

                this._selectionContextMenu.items.push({
                    text: Helper.getTranslation("Einsatz.CopyHere"),
                    onClick: (args) => {
                        const e = args.source;
                        const event = this.getEventById(this._currentlySelectedEventId);
                        if (Helper.hasValue(e) && Helper.hasValue(event)) {
                            const cellStart = Helper.dates.toDate(e.start.value);
                            const eventStart = Helper.dates.toDate(event.Start);
                            const start = new Date(cellStart.getFullYear(), cellStart.getMonth(), cellStart.getDate(), eventStart.getHours(), eventStart.getMinutes());
                            const delta = Helper.dates.toDate(event.End).getTime() - Helper.dates.toDate(event.Start).getTime();
                            const endDate = new Date(Helper.dates.toDate(start).getTime() + delta)
                            this.props.actions.moveEvent(this._currentlySelectedEventId, start, endDate, e.resource, event.ResourceId, false, false);
                        }
                    }
                });
            }


            let renderFlagContextmenu = Config.settings.flagsAreActive && this.props.settings.GroupByResources && (this.props.settings.TimeResolutionType <= this._timeResolutionTypes.Days) && this.props.settings.FlagMode > 0;
            if (renderFlagContextmenu && !Helper.isNullOrEmpty(args.source.resource)) {
                const arr = args.source.resource.split("|");
                renderFlagContextmenu = arr.length == 2 && arr[0].toLowerCase() == "r";
            }
            if (renderFlagContextmenu) {
                const menuItem: DayPilot.MenuItemData = {
                    text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.Flags"],
                    items: []
                }
                this.props.settings.Flags.forEach((flag) => {
                    menuItem.items.push({
                        text: flag.Name,
                        onClick: (e) => {
                            const source = e.source;
                            const arr = source.resource.split("|");
                            if (arr[0] === "r") {
                                const ressNr = arr[1];
                                const [start, end] = this._calculateStartAndEndForFlag(source.start.value, source.end.value)
                                this.props.actions.assignAreaToResource(flag.Id, ressNr, start, end);
                            }
                        }
                    });
                });
                if (menuItem.items.length > 0)
                    menuItem.items.push({ text: "-" });
                menuItem.items.push({
                    text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.RemoveFlags"],
                    onClick: (e) => {
                        const source = e.source;
                        const arr = source.resource.split("|");
                        if (arr[0] === "r") {
                            const ressNr = arr[1];
                            const [start, end] = this._calculateStartAndEndForFlag(source.start.value, source.end.value)
                            this.props.actions.removeFlagsFromResource(ressNr, start, end);
                        }
                    }
                });
                if (Config.user.isSysAdmin) {
                    menuItem.items.push({ text: "-" });
                    menuItem.items.push({
                        text: this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.NewFlag"],
                        onClick: (e) => {
                            const source = e.source;
                            const arr = source.resource.split("|");
                            if (arr[0] === "r") {
                                const ressNr = arr[1];
                                const sheet = General.Sheet.Manager.createSheetWithUrl("PlanningBoardFlag/Edit?closeAfterSave=true");
                                sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: any }) => {
                                    const [start, end] = this._calculateStartAndEndForFlag(source.start.value, source.end.value)
                                    this.props.actions.assignAreaToResource(data.entity.Id, ressNr, start, end);
                                });
                            }
                        }
                    });
                }
                this._selectionContextMenu.items.push(menuItem);
            }
        }
    }

    private _calculateStartAndEndForFlag = (start: string | Date, end: string | Date) => {
        const cleanDateValue = (value: string | Date, addDay: boolean) => {
            const tmp = Helper.dates.toDate(value);
            const result = new Date(tmp.getFullYear(), tmp.getMonth(), (tmp.getDate() + (addDay ? 1 : 0)))
            return Helper.dates.getISODateString(result);
        }

        switch (this.props.settings.TimeResolutionType) {
            case this._timeResolutionTypes.Days:
                return [start, end]
            case this._timeResolutionTypes.Hours:
                return [cleanDateValue(start, false), cleanDateValue(end, true)]
        }
        return [null, null];
    }

    private _initDynamicSettings = (dps: DayPilot.Scheduler, isInit: boolean = false) => {
        let settingsPb = this._data.SettingsPlanningBoard;
        let settings = this.props.settings;


        // Dynamic settings
        dps.rowHeaderColumns = [];

        for (let col of settingsPb.RowHeaderColumns) {
            let width = col.Width;
            let storageWidth = Helper.loadDataFromStorage(`FSM_Scheduler_${Config.user.userName}_Column_Width_${col.Title.toLowerCase()}`)
            if (Helper.hasValue(storageWidth) && Helper.isNumber(storageWidth)) {
                width = storageWidth;
            }
            dps.rowHeaderColumns.push({ "width": width, "title": col.Title == "" ? " " : col.Title, display: col.Title });
        }

        dps.rowHeaderColumns.push()

        const eventBoxesMode = this._data.SettingsPlanningBoard.RenderWholeDaysMode == RenderWholeDaysMode.ShortDaysOnly ? "ShortEventsOnly" : "Always";
        dps.useEventBoxes = settings.WholeDayAssignmentRendering && settings.TimeResolutionType == this._timeResolutionTypes.Days ? eventBoxesMode : "Never";
        dps.rowMarginBottom = 10;

        dps.eventMoveHandling = settingsPb.EventMoveHandling;
        dps.eventResizeHandling = settingsPb.EventResizeHandling;
        dps.timeHeaders = [];
        for (let th of settingsPb.TimeHeaders)
            dps.timeHeaders.push({ "groupBy": th.GroupBy, format: th.Format });

        this._timeHeaderIndexWeek = settingsPb.TimeHeaders.findIndex(x => x.GroupBy == "Week");


        if (!settings.DoNotChangeCellWidth) {
            if (isInit || dps.scale != settingsPb.Scale)
                dps.cellWidth = settingsPb.CellWidth;
        }

        dps.days = settingsPb.Days;
        dps.scale = settingsPb.Scale;
        dps.startDate = Helper.dates.getISODateString(kendo.parseDate(settingsPb.Start));


        if (!DayPilot.Locale.find("$$-custom")) {
            const toDayPilot = (calendar: any):  DayPilot.Locale => {
                return {
                    dayNames: calendar.days.names,
                    dayNamesShort: calendar.days.namesShort,
                    monthNames: calendar.months.names,
                    monthNamesShort: calendar.months.namesAbbr,
                    timePattern: calendar.patterns.t,
                    datePattern: calendar.patterns.d,
                    dateTimePattern: calendar.patterns.G,
                    weekStarts: calendar.firstDay ?? 0,
                    timeFormat: calendar?.patterns?.t?.includes("tt") ? "Clock12Hours" : "Clock24Hours"
                };
            }
            //must have xx-... format 
            DayPilot.Locale.register(new DayPilot.Locale("$$-custom", toDayPilot(kendo.culture().calendars.standard)));
        }
        dps.locale = "$$-custom";

        this.showOnlyWorkTime(true);
        dps.showNonBusiness = !this._showOnlyWorkTime;
        dps.rowMarginTop = (settings.ShowUtilization && (settings.TimeResolutionType == this._timeResolutionTypes.Hours || settings.TimeResolutionType == this._timeResolutionTypes.Days)) ? 15 : 0;

        dps.eventVersionsEnabled = settings.ShowTargetPeriods;
        dps.eventVersionsReserveSpace = settings.ShowTargetPeriods
        dps.eventVersionHeight = settings.ShowTargetPeriods ? 15 : 0;
        dps.eventVersionMargin = settings.ShowTargetPeriods ? 5 : 0;
        dps.durationBarVisible = settings.ShowDegreeOfCompletion;

        if (!this.props.multiSelectActive) {
            dps.allowMultiSelect = false;
            dps.rectangleSelectHandling = "Disabled";
            dps.timeRangeSelectedHandling = "Enabled";
            dps.eventClickHandling = "Enabled";
        } else {
            dps.allowMultiSelect = true;
            dps.rectangleSelectHandling = "EventSelect";
            dps.timeRangeSelectedHandling = "Disabled";
            dps.eventClickHandling = "Select";
        }
    }

    private _onAfterUpdate = () => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.refresh(CapacityRefreshMode.Recompute);
        }
    }
    // Start DayPilot Pro events
    private _onBeforeResHeaderRender = (args: DayPilot.SchedulerBeforeResHeaderRenderArgs) => {

        const escapeId = (str: string)=> {
            return str
                .replace(/[^a-zA-Z0-9_-]/g, "_");
        }
        
        if (this.props.settings.GroupByResources) {
            if (Config.user.useTemplateInResourcePlanning && Helper.hasValue(this.columnTemplate)) {
                this._resourceWithTemplate(args);
            } else {
                this._resourceWithColumns(args);
            }
        } else if (this.props.settings.GroupByProjects) {
            const header = this._data.SettingsPlanningBoard.RowHeaderColumns;
            const res: DayPilot.ResourceData = args.resource;
            const projData = Helper.getArrayItem(this._data.Projects, "ProjNr", res.id as string);
            const colors: { backGroundColor: string, fontColor: string } = this._data.SettingsPlanningBoard["ProjectColors"][args.resource.id];
            let borderTop = "";
            if (this.props.settings.ShowProjectStructure && projData?.LevelCode?.split(".").length == 1)
                borderTop = "3px solid red";

            const classes: Array<string> = [SchedulerResourceHeaderClasses.Column, SchedulerResourceHeaderClasses.NameColumn, SchedulerResourceHeaderClasses.Resource, SchedulerResourceHeaderClasses.Selected];
            
            const rowId = escapeId(`EP_Name_${args.resource.id}`)
            res.html = `<div id="${rowId}" style="border-top: ${borderTop};background: ${colors?.backGroundColor};color: ${colors?.fontColor}; padding-left: 2px;"><div class='${classes.join(" ")}' data-resid='${res.id}'>${res.name}</div></div>`;
            
            for (let index = 0; index < res.columns.length; ++index) {
                const title = Helper.hasValue(header[index]) ? header[index].Title : "";
                const colId = escapeId(`#EP_${title}_${args.resource.id}`)
                let innerColHtml = "";
                if (Helper.hasValue(res.rawColumns[index].html))
                    innerColHtml = res.rawColumns[index].html;
                res.columns[index].html = `<div id="${colId}" style="border-top: ${borderTop};background: ${colors?.backGroundColor};color: ${colors?.fontColor}; padding-left: 2px;"><div data-resid='${res.id}'>${Helper.getValueOrDefault(innerColHtml, "")}</div ></div >`;
                res.columns[index].cssClass = "";
            }
        }
    }

    private _resourceWithColumns = (args: DayPilot.SchedulerBeforeResHeaderRenderArgs) => {
        let res: DayPilot.ResourceData = args.resource;
        const resource = this.getResourceById(args.resource.id);
        if (!resource) return; //this is normal => this._data was updated, but DayPilot not yet ...  
        let img = "";
        const showImage = this.props.settings.ShowProfilePicture;

        if (showImage) {
            const size = 14 + (this.props.settings.NumberOfLinesInEvent * 14);
            if (!Helper.isNullOrEmpty(resource.ImageDocGuid)) {
                img = `<img data-role="profile_picture" style="width: ${size}px; border-radius: 50%" src="${Config.baseUrl}Thumbnail/Get/${resource.ImageDocGuid}" alt=""/>`
            } else {
                const resType = resource.Id.split("|")[0];
                if (resType == "r") {
                    img = DefaultProfilePictureGenerator.generateString({
                        name: `${resource["FirstName"] ?? ""} ${resource["SurName"] ?? ""}`,
                        size: size,
                        background: "bright",
                        form: "circle"
                    });
                } else {
                    img = DefaultProfilePictureGenerator.generateString({
                        name: resource.Text,
                        size: size,
                        background: "dark",
                        form: "square"
                    });
                    //img = `<div style="height: ${size - 2}px; display: flex; justify-content: center;">
                    //    <i style="font-size:42px;height: ${size - 2}px" class='fal fa-${resType == "r" ? "user" : "user-group"}' aria-hidden='true'></i>
                    //</div>`;
                }

            }
            //const width = Helper.loadDataFromStorage(`FSM_Scheduler_${Config.user.userName}_Column_Width_name`);

            img = `<div data-role="profile_picture_wrapper" style="margin-right: 10px; width: ${size}px;">
                    ${img}
                </div>`;
        }


        if ((res.id as string).indexOf("g") == 0) {
            res.html = `<div class='${SchedulerResourceHeaderClasses.Column} ${SchedulerResourceHeaderClasses.NameColumn} ${SchedulerResourceHeaderClasses.Container}' data-resid='${res.id}'>
                            ${img}
                            ${res.html}
                        </div>`;
        }
        let bColor = Helper.hasValue(resource) ? resource.BackGroundColor : "#ffffff";
        let cColor = Helper.hasValue(resource) ? resource.FontColor : "#000000";
        if ((res.id as string).indexOf("r") == 0) {
            const classes: Array<string> = [SchedulerResourceHeaderClasses.Column, SchedulerResourceHeaderClasses.NameColumn, SchedulerResourceHeaderClasses.Resource];
            let externIcon = "";
            const resData = this.getResourceById(res.id as string);
            if (resData != null && resData.TmpGr > 0) {
                classes.push(SchedulerResourceHeaderClasses.External);
                externIcon = "<div style='width: fit-content; margin-left: 5px'><i class='fas fa-handshake-alt fa-fw' aria-hidden='true'></i></div>";
            }
            if (Helper.isNullOrEmpty(bColor)) {
                res.html = `<div class='${classes.join(" ")}' ${args.resource.id == this.props.initialResource ? 'style="font-weight: bold"' : ''} data-resid='${res.id}'>
                                ${img}
                                ${res.html}
                                ${externIcon}
                            </div>`;
            } else {
                let style = `style="background: ${bColor};color: ${cColor}; padding-left: 2px;`;
                if (args.resource.id == this.props.initialResource) {
                    style += 'font-weight: bold;';
                }
                style += '"';
                res.html = `<div id="EP_Name_${args.resource.id}" ${style}">
                                <div class='${classes.join(" ")}' data-resid='${res.id}'>
                                    ${img}
                                    ${res.html}
                                    ${externIcon}
                                </div>
                            </div>`;
            }
        }
        const header = this._data.SettingsPlanningBoard.RowHeaderColumns;
        for (let index = 0; index < res.columns.length; ++index) {
            let innerHtml = res.columns[index].html;
            
            if (Helper.hasValue(res.rawColumns[index])) {
                innerHtml = res.rawColumns[index].html;
            }
            if (Helper.isNullOrEmpty(bColor)) {
                res.columns[index].html = `<div data-resid='${res.id}' ${args.resource.id == this.props.initialResource ? 'style="font-weight: bold"' : ''} >
                                    ${innerHtml}
                                </div>`;
            } else {
                res.columns[index].html = `<div id="EP_${header[index + 1].Title}_${args.resource.id}" style="background: ${bColor};color: ${cColor}; padding-left: 2px; ${args.resource.id == this.props.initialResource ? "font-weight: bold" : ''}">
                                    <div data-resid='${res.id}'>
                                        ${innerHtml}
                                    </div>
                                </div>`;
            }
            res.columns[index].cssClass = "";
        }
    }

    private _resourceWithTemplate = (args: DayPilot.SchedulerBeforeResHeaderRenderArgs) => {
        const res: DayPilot.ResourceData = args.resource;
        const resource = this.getResourceById(res.id);
        if (!resource) return; //this is normal => this._data was updated, but DayPilot not yet ...  

        const resType = resource.Id.split("|")[0];

        let img: string;
        const size = 14 + (this.props.settings.NumberOfLinesInEvent * 14);
        if (!Helper.isNullOrEmpty(resource.ImageDocGuid)) {
            img = `<img data-role="profile_picture" style="width: ${size}px; border-radius: 50%" src="${Config.baseUrl}Thumbnail/Get/${resource.ImageDocGuid}" alt=""/>`
        } else {
            if (resType == "r") {
                img = DefaultProfilePictureGenerator.generateString({
                    name: `${resource["FirstName"] ?? ""} ${resource["SurName"] ?? ""}`,
                    size: size,
                    background: "bright",
                    form: "circle"
                });
            } else {
                img = DefaultProfilePictureGenerator.generateString({
                    name: resource.Text,
                    size: size,
                    background: "dark",
                    form: "square"
                });

            }

            img = `<div data-role="profile_picture_wrapper" style="width: ${size}px;">
                        ${img}
                    </div>`;
        }

        const dataItem = {
            type: resType == "r" ? "resource" : "group",
            name: resource["Text"] ?? "",
            group: this.props.lookups.groups.find((gr: { Value: number; Name: string }) => gr.Value == resource["Grnr"])?.Name,
            grNr: resource["Grnr"],
            mainGroup: this.props.lookups.mainGroups.find((mGr: { Value: number; Name: string }) => mGr.Value == resource["Ogrnr"])?.Name,
            ogrNr: resource["Ogrnr"],
            profilePicture: img,
            color: resource.BackGroundColor ?? "#ffffff",
            isExternal: resource.TmpGr > 0
        };
        res.html = this.columnTemplate(dataItem)
    }


    private _onBeforeEventRender = (args: any) => {
        const event: ResourcePlanningSchedulerEventViewModel = this.getEventById(args.data.id);

        if (event && event.Hidden)
            return;

        let so = Helper.hasValue(event) ? null : this._getSlotById(args.data.id, args.data.resource);
        let schedulerEvent: DayPilot.EventData = args.e;

        let isContainer = false;
        if (Helper.hasValue(event)) {
            isContainer = !event.ResourceId.startsWith('r|');
        }
        if (event || so) {
            if (so == null) {
                schedulerEvent.resizeDisabled = (event.FixStart == 1 && event.FixEnd == 1);// || this.props.slotModeActive;
                let classFixStart = this._data.SettingsPlanningBoard.MarkFixedDelegations && event.FixStart == 1 ? SchedulerClasses.FixedStart : "";
                let classFixEnd = this._data.SettingsPlanningBoard.MarkFixedDelegations && event.FixEnd == 1 ? SchedulerClasses.FixedEnd : "";
                let classFixResource = event.FixResource == 1 ? SchedulerClasses.FixedResource : "";


                const sendStatus = (event.StatusMarkingCode == null || isContainer) ? "" : `<span style='flex-shrink:0;color:${event.StatusMarkingColor};'>&#x${event.StatusMarkingCode}</span>`;
                const iconInfo = Helper.hasValue(event.IconInfo) ? `<span style='flex-shrink:0;color:${event.IconInfo.Color};'>&#x${event.IconInfo.HexCode}</span>` : "";


                const additionalHTML = (Helper.hasValue(event.StatusMarkingCode) || Helper.hasValue(event.IconInfo)) ? `<span style='margin-left: 5px;'>${sendStatus} ${iconInfo}</span>` : null;
                let hint = event.Hint;
                if (this.props.hintTemplateFunc != null) {
                    try {
                        hint = this.props.hintTemplateFunc({ event, settings: this.props.settings, lookups: this.props.lookups });
                    } catch (e) {
                        console.error(`Error in hint template for event:${event.Projnr}/${event.Pindex}. Exception: ${e}`);
                    }
                }
                schedulerEvent.toolTip = hint;
                if (event.Hidden) {
                    schedulerEvent.barHidden = true;
                }

                const notificationIconHtml = event.SendStatus > 0 && Helper.hasValue(event.NotificationState) && Helper.hasValue(event.NotificationState.Icon) && event.UsesApp ? `<span style='flex-shrink:0;margin-left: 5px;vertical-align:top' class="${event.NotificationState.Icon}"></span>` : '';

                const truncateStyle = `flex:1;overflow:hidden;white-space:${this.props.settings.NumberOfLinesInEvent === 1 ? "nowrap" : "normal"};text-overflow:ellipsis;line-height:1.3;`;

                let foreColor = event.ForeColor;
                let backgroundColor = event.BackgroundColor;

                if (this.props.settings.SlaViewActive) {
                    const slaColors = ResourcePlanningHelper.getSlaColors(event);
                    foreColor = slaColors.color;
                    backgroundColor = slaColors.backgroundColor;
                }

                if (this.props.settings.AssignmentGroupingViewActive) {

                    if (this._safeColors == null) {
                        const arr = Helper.ColorNames;
                        this._safeColors = arr.filter(x => x !== 'White' && x !== 'Black' && x !== 'Brown' && x !== 'Maroon' && x !== 'Navy');
                    }

                    let color = 'white';

                    if (event.Gruppierung > 0) {

                        const found = this._colorsAssigmentGrouping.find(x => x.id == event.Gruppierung);
                        if (found != null)
                            color = found.colorName;

                        if (color == 'white') {

                            let item = {} as ColorsWithId;
                            item.id = event.Gruppierung;
                            item.colorName = this._safeColors[this._colorsAssigmentGrouping.length + 1];
                            this._colorsAssigmentGrouping.push(item);
                            color = item.colorName;
                        }
                    }

                    foreColor = 'black';
                    backgroundColor = color;
                }

                const classes = `${classFixStart} ${classFixEnd} ${classFixResource}`;
                schedulerEvent.html = `<div style='z-index:98;width:100%;height:100%' class='${classes}'></div>`;

                let text = Helper.getValueOrDefault(event.Text, "");

                let utilizationText: string = '';
                if (this.props.settings.ShowUtilization &&
                    (this.props.settings.TimeResolutionType == this._timeResolutionTypes.Hours || this.props.settings.TimeResolutionType == this._timeResolutionTypes.Days)) {
                    if (event.ResourceId.startsWith("r|") && event.AssignmentUtilizationInfo != null) {
                        utilizationText = Helper.formatNumber(100 * event.AssignmentUtilizationInfo.workDaysAll / event.AssignmentUtilizationInfo.capacityDaysAll, 0) + "% / " + Helper.formatNumber(event.Arbeitszeit);
                    } else {
                        utilizationText = Helper.formatNumber(event.Arbeitszeit).toString();
                    }
                }

                if (this.props.templateFunc != null) {
                    try {
                        text = this.props.templateFunc({ event, settings: this.props.settings, lookups: this.props.lookups });
                    } catch (e) {
                        console.error(`Error in assignment template for event:${event.Projnr}/${event.Pindex}. Exception: ${e}`);
                    }
                }

                if (utilizationText != '')
                    text = utilizationText + " h   | " + text;

                const drivingTimeIndicator = `<div style ='background-color:${backgroundColor}' class='scheduler-driving-time'></div>`;
                const travelTimeStart = new DayPilot.Date(args.data.start);
                const travelTimeEnd = new DayPilot.Date(args.data.end);
                const workStart = travelTimeStart.addMilliseconds(event.EpochWorkStart - event.EpochStart);
                const workEnd = travelTimeEnd.addMilliseconds(event.EpochWorkEnd - event.EpochEnd);

                let bStyle: string;
                const borderWidth = (this.props.settings.FlagMode == 0 && event.Provisional) ? "2.5px" : "1px";
                const dateDiff = (travelTimeEnd.toDate().valueOf() - travelTimeStart.toDate().valueOf()) / 3600000;

                bStyle = `flex:1;height:100%;color:${foreColor};`
                const textIconLayer = `<div style='${bStyle} display:flex;'><span style='${truncateStyle}'>${text}</span>${additionalHTML ?? ''}${notificationIconHtml}</div>`;

                args.data.areas = [];
                const shortDaysOnly = dateDiff <= 24 || this._data.SettingsPlanningBoard.RenderWholeDaysMode == RenderWholeDaysMode.Always;
                if (this.props.settings.WholeDayAssignmentRendering && shortDaysOnly && this.props.settings.TimeResolutionType != 0) {
                    const newStart = new DayPilot.Date(new Date(travelTimeStart.getYear(), travelTimeStart.getMonth(), travelTimeStart.getDay(), 0, 0, 0, 0), true);
                    const newEnd = new DayPilot.Date(new Date(travelTimeEnd.getYear(), travelTimeEnd.getMonth(), travelTimeEnd.getDay() + 1, 0, 0, 0, 0), true);

                    this.renderWorkingtime(newStart, newEnd, args, backgroundColor, event, textIconLayer, borderWidth);
                }
                else {
                    if (event.EpochStart != event.EpochWorkStart) {
                        args.data.areas.push({
                            start: travelTimeStart,
                            end: workStart,
                            top: 0,
                            bottom: 0,
                            html: drivingTimeIndicator,
                            style: `margin-top:1px;margin-bottom:1px;display:flex;flex-direction:column`
                        });
                    }

                    this.renderWorkingtime(workStart, workEnd, args, backgroundColor, event, textIconLayer, borderWidth);

                    if (event.EpochEnd != event.EpochWorkEnd) {
                        args.data.areas.push({
                            start: workEnd,
                            end: travelTimeEnd,
                            top: 0,
                            bottom: 0,
                            html: drivingTimeIndicator,
                            style: `margin-top:1px;margin-bottom:1px;display:flex;flex-direction:column`
                        });
                    }
                }

                schedulerEvent.cssClass = this._currentlySelectedEventId === args.data.id ? "scheduler_white_event_selected" : "";
            } else {
                let color = ResourcePlanningHelper.getSlotColor(this.props.settings.GeomapFilterRouteResultGraduation, so);

                let toolTip: string;
                let times: string;

                const slotText: string[] = [];

                const ttOutward = JourneyHelper.getJourneyLegText(so.wayThere, "wayThere", false);
                slotText.push(JourneyHelper.getJourneyLegText(so.wayThere, "wayThere", true));

                let ttReturn = JourneyHelper.getJourneyLegText(so.wayBack, "wayBack", false);
                slotText.push(JourneyHelper.getJourneyLegText(so.wayBack, "wayBack", true));

                let skillsMatch: string = "";

                if (this.props.slotSearchSettings.considerSkills == ConsiderSkillMode.Fuzzy) {
                    let percent = "100%"; // "Matching skills to {percent}"

                    if (so.skillsRequired != 0) {
                        percent = (so.skillsProvided * 100 / so.skillsRequired).toFixed(0) + "%";
                    }

                    slotText.push(percent);
                    skillsMatch = "\n\n" + Helper.getTranslation("WebSMS.Skills.MatchingPercent").replace("{percent}", percent);

                    if (so.skillsRequired != so.skillsProvided) {
                        skillsMatch += "\n" + Helper.getTranslation("WebSMS.Skills.FollowingNotSufficient")// "Following skills are not sufficient:"
                        so.missingSkills.forEach(missing => {
                            skillsMatch += "\n" + missing.skillGroup + " / " + missing.skill + " : " + missing.available + "/" + missing.requirement;
                        });
                    }

                }

                toolTip = ttOutward + " / " + ttReturn;

                const home = this.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.Home"];
                const assingment = this.props.translations["Einsatz.Balkeninfo"];

                let fromHome = so.traveldataInfo.fromHome ? " (" + home + ") " : " (" + assingment + ")";
                if (Helper.hasValue(so.traveldataInfo.fromInfo))
                    fromHome += " " + so.traveldataInfo.fromInfo;

                let backHome = so.traveldataInfo.backHome ? " (" + home + ") " : " (" + assingment + ")";
                if (Helper.hasValue(so.traveldataInfo.backInfo))
                    backHome += " " + so.traveldataInfo.backInfo

                const summary = Helper.hasValue(so.traveldataInfo.summary) ? " " + so.traveldataInfo.summary : "";

                times = this.props.translations["WebSMS.ServiceReport.Hinreise"] + ": " + Helper.dates.toString(so.assignmentTimes.startIst, true) + fromHome + "\n" +
                    this.props.translations["WebSMS.GeneralSettings.Arbeitsbeginn"] + ": " + Helper.dates.toString(so.assignmentTimes.arbeitsBeginn, true) + summary + "\n" +
                    this.props.translations["WebSMS.GeneralSettings.Arbeitsende"] + ": " + Helper.dates.toString(so.assignmentTimes.arbeitsEnde, true) + summary + "\n" +
                    this.props.translations["WebSMS.ServiceReport.Rückreise"] + ": " + Helper.dates.toString(so.assignmentTimes.endeIst, true) + backHome;

                schedulerEvent.toolTip = toolTip + "\n" + times + skillsMatch;
                schedulerEvent.moveDisabled = true;
                schedulerEvent.doubleClickDisabled = true;
                schedulerEvent.moveDisabled = true;
                schedulerEvent.resizeDisabled = true;

                schedulerEvent.cssClass = this._currentlySelectedEventId === args.data.id ? "scheduler_white_event_selected" : "";

                const text = slotText.join("\\");

                schedulerEvent.html =
                    `<div style='flex:1;padding:2px;height:100%;background-color:${color};overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'>${text}</div>`;

            }
        }
    }

    private _afterEventRender = (args: DayPilot.SchedulerAfterEventRenderArgs) => {
        //TODO: check this
        //let so = Helper.hasValue(event) ? null : this._getSlotById(args.e.data.id, args.e.data.resource);
        let so = Helper.hasValue(args) && Helper.hasValue(args.e) ? this._getSlotById(args.e.data.id, args.e.data.resource) : null;
        if (Helper.hasValue(so)) {
            this.addSlotEvents(args);
        }
    }

    private addSlotEvents = (args: DayPilot.SchedulerAfterEventRenderArgs) => {
        args.div.ondragover = (e) => {
            const hasMyType = e.dataTransfer.types.some(function (type) { return type === "innosoft/drop-on-slot"; });
            if (hasMyType) {
                e.preventDefault();
                args.div.style.outline = "2px solid red";
            }
        };
        args.div.ondragleave = () => {
            args.div.style.outline = null;
        }
        args.div.ondrop = () => {
            args.div.style.outline = null;
            const resource = Helper.getArrayItem(this.props.currentSlots, "id", args.e.resource());
            const slotObject = Helper.getArrayItem(resource.slots, "id", args.e.id());
            this.props.actions.useSlot(args.e.resource(), slotObject);
        }
    }

    private registerDragDropEvents = (args: DayPilot.SchedulerAfterCellRenderArgs) => {
        args.div.ondragover = (e) => {
            const hasMyType = e.dataTransfer.types.some(function (type) { return type === "innosoft/drop-on-day"; });
            if (hasMyType) {
                e.preventDefault();
                args.div.style.border = "5px solid black";
            }
        };
        args.div.ondragleave = () => {
            args.div.style.border = null;
        }
        args.div.ondrop = (e) => {
            args.div.style.border = null;
            const daypilotJson = JSON.parse(e.dataTransfer.getData("innosoft/drop-on-day"));
            this.props.actions.moveEvent(daypilotJson.id, args.cell.start.toDateLocal(), args.cell.end.toDateLocal(), args.cell.resource, null, false, false);
        }
    }

    private _onBeforeCellRender = (args: SchedulerBeforeCellRenderArgs) => {
        if (Config.settings.flagsAreActive && this.props.settings.TimeResolutionType <= this._timeResolutionTypes.Days && this.props.settings.FlagMode > 0) {
            this._flagCellColoring(args);
        } else {
            this._standardCellColoring(args);
        }
    }

    private _standardCellColoring = (args: SchedulerBeforeCellRenderArgs) => {
        const simpleMode = !this.props.settings.GroupByResources && this._data.SettingsPlanningBoard.SpecialCalendarActivated;

        let resource: ResourcePlanningSchedulerResourceViewModel = null;
        let isHumanResource = false;

        const cell = args.cell;
        const dspStartDate = (this._dps.startDate as DayPilot.Date);

        let dayOffsetRoster = 0;
        let dayInfo: RosterDayInfoViewModel = null;

        // Einfärbung der Zellen nur im Modus Tag und Stunden vornehmen            
        if (this.props.settings.TimeResolutionType == 0 || this.props.settings.TimeResolutionType == 1) {

            //heute 
            if (cell.start == this._dpsToday && this.props.settings.TimeResolutionType == 1) {
                cell.cssClass = SchedulerClasses.CurrentDay;
            }

            if (!simpleMode) {
                let dayOfWeek = cell.start.dayOfWeek();
                const showOnlyWorktime = this.showOnlyWorkTime(false);

                dayOffsetRoster = this.props.settings.TimeResolutionType == 0 || showOnlyWorktime ?
                    this.dayPilotDateDiffInDays(this._dps.startDate as DayPilot.Date, cell.start) :
                    cell.x;

                resource = this.getResourceById(cell.resource); //this._resourceCache.get(cell.resource);
                if (resource != null) {
                    isHumanResource = resource.Id.indexOf("r") == 0;
                    dayInfo = GetRosterInfoFromArray(this._data.RosterDayInfos, resource.RosterDayInfo, dayOffsetRoster);
                }


                // Wochenendschema beachten
                if (!showOnlyWorktime) {
                    if (dayInfo && IsWeekend(dayInfo)) {
                        if (isHumanResource) {
                            let weekendDay = this.props.settings.AllWeekendDays.find(x => x.Id == resource.WochenendId && x.DayOfWeek == dayOfWeek);
                            if (Helper.hasValue(weekendDay)) {
                                cell.html = `<div style = 'width: 100%; height: 100%;' title= '${weekendDay.Description}' > </div>`;
                                cell.cssClass = SchedulerClasses.WeekEndSchema + weekendDay.Id + "_" + weekendDay.DayOfWeek;
                            } else
                                cell.cssClass = SchedulerClasses.WeekEnd;
                        } else
                            cell.cssClass = SchedulerClasses.WeekEnd;
                    } else {
                        if (dayInfo === null && (dayOfWeek == 0 || dayOfWeek == 6)) {
                            cell.cssClass = SchedulerClasses.WeekEnd;
                        }
                    }
                }

                // Feiertage bei Ressourcen markieren
                if (dayInfo && IsHoliday(dayInfo) && isHumanResource || !this._data.SettingsPlanningBoard.SpecialCalendarActivated) {
                    const kalenderId = this._data.SettingsPlanningBoard.SpecialCalendarActivated ? resource.KalenderId : -1;
                    let filterFreedays = this._data.Freedays.filter(x => x.KalenderId == kalenderId && (x.DayAsPilotDate == cell.start));
                    if (filterFreedays.length > 0) {
                        if (filterFreedays[0].KalenderId == -1) {
                            cell.html = `<div style = 'width: 100%; height: 100%;' title= '${filterFreedays[0].Name}' > </div>`;
                            cell.cssClass = SchedulerClasses.FreeDay;
                        } else {
                            cell.html = `<div style='background-color: ${filterFreedays[0].Color}; ${IsHalfHoliday(dayInfo) ?
                                `background: repeating-linear-gradient(135deg, transparent, transparent 5px,${filterFreedays[0].Color} 5px,${filterFreedays[0].Color} 10px);` :
                                ""};width: 100%; height: 100%;' title= '${filterFreedays[0].Name}' > </div>`;
                        }
                    }
                }
            }
        }
        else
            if (this.props.settings.TimeResolutionType == 2 || this.props.settings.TimeResolutionType == 3) {
                resource = this.getResourceById(cell.resource);
                if (resource != null && !simpleMode) {
                    isHumanResource = resource.Id.indexOf("r") == 0;
                }

                let colorHeaderInTodayColor: boolean;

                if (this.props.settings.TimeResolutionType == 2) {
                    const cellDate = moment(cell.start.toDate());
                    const currentDate = moment(new Date());
                    colorHeaderInTodayColor = cellDate.isoWeek() == currentDate.isoWeek() && cellDate.year() == currentDate.year();
                } else {
                    const cellDate = cell.start.toDate();
                    const currentDate = new Date();
                    colorHeaderInTodayColor = cellDate.getUTCMonth() == currentDate.getUTCMonth() && cellDate.getFullYear() == currentDate.getFullYear();
                }

                if (colorHeaderInTodayColor) {
                    cell.cssClass = SchedulerClasses.CurrentDay;
                }
            }

        if (this._data.SettingsPlanningBoard.Scale == "Hour" && !simpleMode) {
            let coloredTime = [];
            for (let i = this._dps.businessBeginsHour + this._data.CapacitySettings.BusinessTimeExpandViewByXHours - 1; i >= 0; i--) {
                coloredTime.push(i);
            }
            for (let j = this._dps.businessEndsHour - +this._data.CapacitySettings.BusinessTimeExpandViewByXHours; j <= 23; j++) {
                coloredTime.push(j);

            }
            for (let x = 0; x < coloredTime.length; x++) {
                if (cell.start.getHours() === coloredTime[x]) {
                    cell.cssClass = SchedulerClasses.WeekEnd;
                }
            }
        }

        if (Helper.hasValue(cell.properties.cssClass) && cell.properties.cssClass.indexOf(SchedulerClasses.Overload) >= 0) {
            cell.cssClass += " " + SchedulerClasses.Overload;
        }

        if (isHumanResource && (Helper.hasValue(resource?.Bis) || Helper.hasValue(resource?.Seit))) {
            let isInactive = (Helper.hasValue(resource?.Bis) && this.dayPilotDateDiffInDays(cell.start, resource?.BisAsPilotDay) <= 0) ||
                (Helper.hasValue(resource?.Seit) && this.dayPilotDateDiffInDays(resource?.SeitAsPilotDay, cell.start) < 0);

            if (!isInactive && (this.props.settings.TimeResolutionType == 2 || this.props.settings.TimeResolutionType == 3)) {
                isInactive = (Helper.hasValue(resource?.Seit) && this.isDayPilotDateInBetween(resource?.SeitAsPilotDay, cell.start, cell.end)) ||
                    (Helper.hasValue(resource?.Bis) && this.isDayPilotDateInBetween(resource?.BisAsPilotDay, cell.start, cell.end));
            }

            if (isInactive)
                cell.cssClass = SchedulerClasses.WeekEnd;
        }

        // Auslastung in Zelle anzeigen
        // Bei Wochenenden wird die Wochenendeinstellung der Einsätze ausgewertet
        if (!simpleMode && this.props.settings.ShowUtilization &&
            (this.props.settings.TimeResolutionType == 0 || this.props.settings.TimeResolutionType == 1)) {
            let utilization = 0;
            let maxCapa = dayInfo?.c;
            if (this.props.settings.TimeResolutionType == 0) {
                let uAbsent = 0;
                let uWork = 0;
                this._data.Events.filter(x => x.ResourceId == cell.resource &&
                    this.isDayPilotDateInBetween(cell.start, x.StartPilotDate, x.EndPilotDate))
                    .forEach(event => {
                        if (event.AssignmentUtilizationInfo == null)
                            return;

                        if (cell.resource.indexOf("r") == 0) {
                            let idx = -1;
                            if (this.isDayPilotDateInBetween(cell.start, event.StartPilotDate, event.EndPilotDate)) {
                                if (event.AssignmentUtilizationInfo.offset >= 0)
                                    idx = this.dayPilotDateDiffInDays(event.StartPilotDate, cell.start);
                                else
                                    idx = this.dayPilotDateDiffInDays(dspStartDate, cell.start);
                            }

                            if (idx > -1) {
                                const wPerDay = this.props.settings.IgnoreUtilTravelTimes ? event.AssignmentUtilizationInfo.work[idx] / 60 :
                                    (event.AssignmentUtilizationInfo.work[idx] + event.AssignmentUtilizationInfo.arrival[idx] + event.AssignmentUtilizationInfo.departure[idx]) / 60;
                                if (IsEventType(event) !== AssignmentType.Work)
                                    uAbsent += wPerDay;
                                else
                                    uWork += wPerDay;
                                if (event.AssignmentUtilizationInfo.capacity[idx] / 60 > maxCapa)
                                    maxCapa = event.AssignmentUtilizationInfo.capacity[idx] / 60;
                            }
                        }
                    });
                utilization = (Math.min(uAbsent, dayInfo?.c) + uWork) / dayInfo?.c * 100;
            } else {
                if (isHumanResource) {
                    let uAbsent = 0;
                    let uWork = 0;
                    cell.events().forEach((ev) => {
                        const event = this.getEventById(ev.id());
                        if (event) {
                            if (event.AssignmentUtilizationInfo == null)
                                return;
                            //const _start = kendo.parseDate(event.Start);
                            //const _end = kendo.parseDate(event.End);
                            let idx = -1;
                            if (this.isDayPilotDateInBetween(cell.start, event.StartPilotDate, event.EndPilotDate)) {
                                if (event.AssignmentUtilizationInfo.offset >= 0)
                                    idx = this.dayPilotDateDiffInDays(event.StartPilotDate, cell.start);
                                else
                                    idx = this.dayPilotDateDiffInDays(dspStartDate, cell.start);
                            }
                            if (idx > -1) {
                                const wPerDay = this.props.settings.IgnoreUtilTravelTimes ? event.AssignmentUtilizationInfo.work[idx] / 60 :
                                    (event.AssignmentUtilizationInfo.work[idx] + event.AssignmentUtilizationInfo.arrival[idx] + event.AssignmentUtilizationInfo.departure[idx]) / 60;
                                if (IsEventType(event) !== AssignmentType.Work)
                                    uAbsent += wPerDay;
                                else
                                    uWork += wPerDay;
                                if (event.AssignmentUtilizationInfo.capacity[idx] / 60 > maxCapa)
                                    maxCapa = event.AssignmentUtilizationInfo.capacity[idx] / 60;
                            }
                        }
                    });
                    utilization = maxCapa !== 0 ? (Math.min(uAbsent, maxCapa) + uWork) / maxCapa * 100 : 0;
                }
            }
            if (Math.round(utilization) > 0) {
                let opacity = Math.max(utilization / 100, 0.6);
                args.cell.html = (args.cell.html ?? "") + "<div style='position: absolute; left: 0; top:0; right: 0; height: 15px; padding-left: 3px; background-color: red; color:white; opacity: " + opacity + ";'>" + Helper.formatNumber(utilization, 0) + "%</div>";
            }
        }
    }

    private _flagCellColoring = (args: SchedulerBeforeCellRenderArgs) => {
        const cell = args.cell;
        if (Helper.hasValue(this._data.SettingsPlanningBoard.GantColoring) && cell.resource.indexOf("r|") == 0) {
            const info = this
                ._data
                .SettingsPlanningBoard
                .GantColoring
                .find((item) => {
                    if (`r|${item.RessNr}` !== cell.resource)
                        return false;
                    let tmp = Helper.dates.toDate(item.Day);
                    const itemDay = new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate());
                    tmp = Helper.dates.toDate(cell.start["value"]);
                    const cellDay = new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate());
                    return itemDay.getTime() === cellDay.getTime()
                });


            const dayOfWeek = cell.start.dayOfWeek();
            const dateAsddMMyyyy = cell.start.toString("dd.MM.yyyy");
            let kalenderId = -1;
            let resourceHuman = this.getResourceById(cell.resource);
            if (!resourceHuman) return; //this is normal => this._data was updated, but DayPilot not yet ...  
            if (this._data.SettingsPlanningBoard.SpecialCalendarActivated) {
                kalenderId = resourceHuman.KalenderId;
            }

            let isWeekend = dayOfWeek == 0 || dayOfWeek == 6;
            // Wochenendschema beachten
            if (this.props.settings.HatcheWeekEndInFlagView && resourceHuman.WochenendId !== null) {
                let weekendDays = this.props.settings.AllWeekendDays.filter(x => x.Id == resourceHuman.WochenendId && x.DayOfWeek == dayOfWeek);
                isWeekend = weekendDays.length > 0;
            }

            const hatcheWeekEndInFlagView = this.props.settings.HatcheWeekEndInFlagView && isWeekend;
            const hatcheHolidayInFlagView = this.props.settings.HatcheHolidayInFlagView && this._data.Freedays.findIndex(x => x.KalenderId == kalenderId && x.Day == dateAsddMMyyyy) > -1;

            if (Helper.hasValue(info)) {

                let backGroundColor = `background-color: ${info.FlagColor}`;
                let title = info.FlagName;


                if (hatcheHolidayInFlagView) {
                    title += ` | ${this._data.Freedays.find(x => x.KalenderId == kalenderId && x.Day == dateAsddMMyyyy).Name}`
                }
                if (hatcheWeekEndInFlagView) {
                    title += ` | ${Config.translations.datetime.weekend}`
                }
                if (hatcheWeekEndInFlagView || hatcheHolidayInFlagView) {
                    backGroundColor = `background: repeating-linear-gradient(135deg, transparent, transparent 5px, ${info.FlagColor} 5px, ${info.FlagColor} 10px)`;
                }
                cell.html = `<div title="${title}" style="width: 100%; height: 100%;${backGroundColor};"></div>`
            } else if (hatcheWeekEndInFlagView) {
                cell.html = `<div title="${Config.translations.datetime.weekend}" style="width: 100%; height: 100%;background: repeating-linear-gradient(135deg, transparent, transparent 5px ,#f5f5f5 5px, #f5f5f5 10px);"></div>`
            } else if (hatcheHolidayInFlagView) {
                cell.html = `<div title="${this._data.Freedays.find(x => x.KalenderId == kalenderId && x.Day == dateAsddMMyyyy).Name}" style="width: 100%; height: 100%;background: repeating-linear-gradient(135deg, transparent, transparent 5px,#f5f5f5 5px, #f5f5f5 10px);"></div>`
            }

        }
    }

    private _onBeforeTimeHeaderRender = (args: OnBeforeTimeHeaderRenderArgs) => {
        if (args.header.level === this._timeHeaderIndexWeek) {
            args.header.html = "{0} ".replace("{0}", this.props.translations["WebSMS.ResourcePlanningScheduler.Kalenderwoche"]) + args.header.text;
        }

        const timeType = this.props.settings.TimeResolutionType.toString();
        const level = args.header.level.toString();
        if ((Object.keys(this._clickableHeaders).indexOf(timeType) > -1) && (this._clickableHeaders[timeType].indexOf(level) > -1)) {
            args.header.cssClass = "scheduler_white_timeheader_clickable";
        }

        let colorHeaderInTodayColor = false;
        switch (this.props.settings.TimeResolutionType) {
            case 0:
                colorHeaderInTodayColor = args.header.start == this._dpsToday && args.header.level == 1;
                break;
            case 1:
                colorHeaderInTodayColor = args.header.start == this._dpsToday && args.header.level == 2;
                break;
            case 2:
                if (args.header.level == 1) {
                    const headerDate = moment(args.header.start.toDate())
                    const currentDate = moment(new Date());
                    colorHeaderInTodayColor = headerDate.isoWeek() == currentDate.isoWeek() && headerDate.year() == currentDate.year();
                }
                break;
            case 3:
                if (args.header.level == 1) {
                    const headerDate = args.header.start.toDate();
                    const currentDate = new Date();
                    colorHeaderInTodayColor = headerDate.getUTCMonth() == currentDate.getUTCMonth() && headerDate.getFullYear() == currentDate.getFullYear();
                }
                break;
            default:
                break;
        }
        const backgroundColor = this._data.SettingsPlanningBoard.BackgroundColorToday;
        if (colorHeaderInTodayColor && !Helper.isNullOrEmpty(backgroundColor)) {
            const fontColor = StyleHelper.getFontColor(backgroundColor);
            args.header.backColor = backgroundColor;
            args.header["fontColor"] = fontColor;
        }
    }

    private _clickableHeaders = {
        "0": ["0"],
        "1": ["0", "1", "2"],
        "2": ["0", "1"],
        "3": ["0", "1"]
    };

    private _onBeforeRowHeaderRender = (args: any) => {
        const splittedId = args.row.data.id.split("|");
        if (this.props.geomapViewMode === GeomapViewMode.ResourceView && splittedId[0] === "r") {
            const item = Helper.getArrayItem(this.props.geomapRouteColors, "ressNr", splittedId[1]);
            if (Helper.hasValue(item)) {
                const color = item.color;
                args.row.areas = [
                    { right: 2, top: 2, bottom: 2, width: 6, backColor: color }
                ];
            }
        } else {
            args.row.areas = [];
        }
    }

    private _handleEventMove = async (e: DayPilot.Event, newStart: DayPilot.Date, newEnd: DayPilot.Date, newResource: string, external: boolean, ctrl: boolean, shift: boolean, resizeAction: boolean) => {
        if (!resizeAction && shift == true && this.props.settings.GroupByResources) {
            this.props.actions.copyEvent(e.id(), newStart.toDateLocal(), newEnd.toDateLocal(), newResource);
        } else {
            const moveAssignment = await this._checkIfMoveEvent(e, newStart, newEnd, newResource);
            if (moveAssignment) {
                const oldRess = Helper.hasValue(e.data.resource) ? e.data.resource : this.getEventById(e.id()).ResourceId;
                this.props.actions.moveEvent(e.id(), newStart.toDateLocal(), newEnd.toDateLocal(), newResource, oldRess, resizeAction, false);
            }
        }
        if (external || ctrl) {
            //implicitly use 
        }
    }

    private _checkIfMoveEvent = async (e: DayPilot.Event, newStart: DayPilot.Date, newEnd: DayPilot.Date, newResource: string) => {
        if (e.resource() == newResource && e.start() == newStart && e.end() == newEnd)
            return false;

        return !Config.user.queryAssignmentShift || await DialogHelper.confirm(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ReallyMove"));
    }

    private _handleRowSelected = (args: any) => {
        let row: DayPilot.Row = args.row;
        if (this._dps.rows.selection.isSelected(row)) {
            //Kein Multiselect
            this._dps.rows.selection.clear();
            this._dps.rows.selection.add(row);
        } else {
            this._dps.rows.selection.remove(row);
        }

        this._dps.rows.update(row);

        if (this.state.lastSelectedRow) {
            const oldRow = this._dps.rows.find(r => r.id == this.state.lastSelectedRow);
            if (oldRow)
                this._dps.rows.update(oldRow);
        }
        this.setState({ lastSelectedRow: row.id })

        if (this.props.selectedResourceChanged)
            this.props.selectedResourceChanged(row.id, args.selected);
    }

    private _handleResourceContextMenuClick = (type: "new" | "newPM" | "open", e: any) => {
        if (type == "new") {
            this.props.actions.newFromResource(e.id);
        } else if (type == "newPM") {
            this.props.actions.newPMFromResource(e.id);
        } else if (type == "open") {
            this.props.actions.openResource(e.id);
        }
    }

    private _handleSchedulerEventContextMenuClick = (type: "open" | "delete" | "copy" | "split" | "copyToResources" | "splitToResources"
        | "calculateRoute" | "fitToWorkingTime" | "calculateTravelTimes" | "calculateHomewardJourney" | "viewSlot"
        | "useSlot" | "changeStartTime", e: DayPilot.Event) => {
        switch (type) {
            case "open":
                this.props.actions.openEvent(e.id(), e.resource());
                break;
            case "delete":
                this.props.actions.deleteEvent(e.id());
                break;
            case "copy":
                if (this._currentlySelectedEventId != null) {
                    let target = this._dps.events.find(this._currentlySelectedEventId);

                    if (target != null) {
                        let eventVm = this.getEventById(this._currentlySelectedEventId);
                        this.props.actions.copyEvent(e.id(), e.start().toDateLocal(), e.end().toDateLocal(), eventVm.ResourceId);
                    }
                }
                break;
            case "split":
                if (this._currentlySelectedEventId != null) {
                    let target = this._dps.events.find(this._currentlySelectedEventId);

                    if (target != null) {
                        let eventVm = this.getEventById(this._currentlySelectedEventId);
                        this.props.actions.splitEvent(e.id(), eventVm.ResourceId);
                    }
                }
                break;
            case "copyToResources":
                if (this._currentlySelectedEventId != null) {
                    let target = this._dps.events.find(this._currentlySelectedEventId);

                    if (target != null) {
                        this.props.actions.copyToResources(e.id());
                    }
                }
                break;
            case "splitToResources":
                if (this._currentlySelectedEventId != null) {
                    let target = this._dps.events.find(this._currentlySelectedEventId);

                    if (target != null) {
                        this.props.actions.splitToResources(e.id());
                    }
                }
                break;
            case "calculateRoute":
                this.props.actions.calculateRoute(this._currentlySelectedEventId);
                break;
            case "calculateTravelTimes":
                this.props.actions.calculateTravelTimes(this._currentlySelectedEventId);
                break;
            case "calculateHomewardJourney":
                this.props.actions.calculateTravelTimes(this._currentlySelectedEventId);
                break;
            case "fitToWorkingTime":
                if (this._currentlySelectedEventId != null) {
                    let target = this._dps.events.find(this._currentlySelectedEventId);

                    if (target != null) {
                        this.props.actions.fitToWorkingTime(e.id(), e.resource());
                    }
                }
                break;
            case "viewSlot":
                this.props.actions.openSlot(e);
                break;
            case "useSlot":
                const resource = Helper.getArrayItem(this.props.currentSlots, "id", e.resource());
                const slotObject = Helper.getArrayItem(resource.slots, "id", e.id());
                this.props.actions.useSlot(e.resource(), slotObject);
                break;
            case "changeStartTime":
                this.getStartDelta(new Date(e.start().toString())).then((delta) => {
                    if (Helper.hasValue(delta) && !isNaN(delta)) {
                        const newStart = Helper.dates.addMinutes(e.start().toDateLocal(), delta);
                        const newEnd = Helper.dates.addMinutes(e.end().toDateLocal(), delta);
                        this.props.actions.moveEvent(e.id(), newStart, newEnd, e.resource(), e.resource(), false, true);
                    }
                })
                break;
        }
    }

    private getStartDelta = (defaultValue: Date) => {
        return new Promise<number>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            let value = defaultValue;
            const dialogProps: DialogProps = {
                title: Helper.getTranslation("Einsatz.EnterNewStart"),
                actions: [
                    {
                        label: Config.translations.cancel,
                        action: () => {
                            resolve(null);
                        }
                    },
                    {
                        label: Config.translations.ok,
                        action: () => {
                            const oldStart = new Date(defaultValue);
                            const newStart = new Date(value);

                            let diff = (newStart.getTime() - oldStart.getTime()) / 1000;
                            diff /= 60;

                            resolve(parseInt(diff.toString()));
                        },
                        primary: true
                    }
                ],
                afterClose: () => {
                    targetElement[0].remove();
                }
            };

            const dateTimePickerProps = ComponentHelper.createFactory().getDefaultDateTimePickerProps();
            dateTimePickerProps.value = value;
            dateTimePickerProps.onChange = (_, newValue) => {
                value = newValue;
            }
            ReactDOM.render(
                <Dialog {...dialogProps} open={true}>
                    <DateTimePicker {...dateTimePickerProps} />
                </Dialog>, targetElement[0]);
        })
    }

    private _handleSchedulerEventContextMenuGrouppingClick = (type: "new" | "delete" | "list" | "change" | "last", e: DayPilot.Event, last: number = 0) => {
        if (type == "new") {
            this.props.actions.newAssigmentGrouping(e.id());
        } else if (type == "delete") {
            this.props.actions.deleteAssigmentGrouping(e.id());
        } else if (type == "list") {
            this.props.actions.listAssigmentGrouping(e.id());
        } else if (type == "change") {
            this.props.actions.changeAssigmentGrouping(e.id());
        } else if (type == "last") {
            this.props.actions.changeToLastAssigmentGrouping(e.id(), last);
        }
    }

    private _handleSchedulerSelectionContextMenuClick = (type: "new" | "newPM" | "copySelected", e: DayPilot.Selection) => {
        if (type == "new") {
            this.props.actions.newFromSelection(e.resource, e.start.toDateLocal(), e.end.toDateLocal());
        } else if (type == "newPM") {
            this.props.actions.newPMFromSelection(e.resource, e.start.toDateLocal(), e.end.toDateLocal());
        } else if (type == "copySelected") {
            if (this._currentlySelectedEventId != null) {
                let target = this._dps.events.find(this._currentlySelectedEventId);

                if (target != null) {
                    let dateDiff = target.end().toDateLocal().getTime() - target.start().toDateLocal().getTime();
                    let newEnd = e.start.addTime(dateDiff);
                    this.props.actions.copyEvent(this._currentlySelectedEventId, e.start.toDateLocal(), newEnd.toDateLocal(), e.resource);
                }
            }
        }

        this._dps.clearSelection();
    }
    // End DayPilot Pro events

    // Start helper
    private _onHorizontalScroll = (x: number) => {
        this._schedulerCurrentX = x;
        if (Helper.hasValue(this._capacityDiagram)) {
            this._capacityDiagram.updateScrollPosition(x);
        }
    }

    private _hasScrollBar = () => {
        return Helper.hasVerticalScrollBar(this._assignmentArea);
    }

    private _updateCapacityDiagramPaddingFiller = () => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.updatePaddingFillerWidth(Helper.hasVerticalScrollBar(this._assignmentArea));
        }
    }

    private _updateCapacityDiagramLegendWidth = () => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.updateLegendWidth();
        }
    }

    private _refreshCapacity = (mode: CapacityRefreshMode) => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.refresh(mode);
        }
    }

    private _refreshLinks = () => {
        let links: Array<DayPilot.LinkData> = [];

        const events_with_prevs = this._data.Events.filter(x => x.WayThere != null && Helper.hasValue(x.WayThere.prevAssignmentId));

        for (let i = 0; i < events_with_prevs.length; ++i) {
            const endAssignment = events_with_prevs[i];
            const startAssignment = this._data.Events.find(x => x.IsGuid == endAssignment.WayThere.prevAssignmentId);

            if (Helper.hasValue(startAssignment)) {
                if (startAssignment.ResourceId == endAssignment.ResourceId && startAssignment.WayThere != null && startAssignment.WayBack == null &&
                    Helper.dates.dateDiffInDays(startAssignment.End, endAssignment.Start) <= 1) {
                    links.push({
                        from: startAssignment.Id,
                        to: endAssignment.Id,
                        type: "FinishToStart",
                        color: "black"
                    });
                }
            }
        }

        this._dps.links.list = links;
    }

    private _handleRowFilter = (args: DayPilot.SchedulerRowFilterArgs) => {
        this._capacityDiagram.handleResourceRowFilter(args);
    }

    private _handleTimeHeaderClicked = (args: any) => {
        this.props.timeHeaderClicked(args);
    }

    private _getSlotById = (id: string, resourceId: string): ResourceSlot => {
        const resSlots = this.props.currentSlots.filter(r => r.id === resourceId)[0];
        return Helper.hasValue(resSlots) ? Helper.getArrayItem(resSlots.slots, "id", id) : null;
    }

    // Fügt Resourcen hinzu, die sich aus einer Gruppierung der Events ergeben (z.B. Projekt, Adressen)
    private _addResources = (groupByProperty: keyof ResourcePlanningSchedulerEventViewModel, events: Array<ResourcePlanningSchedulerEventViewModel>) => {
        let currentValue = null;
        for (let event of events.sort((n1, n2) => {
            if (n1[groupByProperty] > n2[groupByProperty]) {
                return 1;
            }

            if (n1[groupByProperty] < n2[groupByProperty]) {
                return -1;
            }

            return 0;
        })) {
            if (currentValue !== event[groupByProperty]) {
                currentValue = event[groupByProperty];
                let columns = [];
                for (let column of this._data.SettingsPlanningBoard.GroupByColumns)
                    columns.push({ html: column === null ? "" : event[column] });

                this._dps.resources.push(
                    {
                        id: event[groupByProperty] as string,
                        name: event[groupByProperty] as string,
                        columns: columns,
                        rawColumns: JSON.parse(JSON.stringify(columns))
                    }
                );
            }
        }
    }

    private _addResourcesByProjects = (groupByProperty: string, projects: ResourcePlanningSchedulerDataViewModel["Projects"]) => {
        for (let project of projects) {
            let columns = [];
            for (let column of this._data.SettingsPlanningBoard.GroupByProjectColumns)
                columns.push({ html: column === null ? "" : project[column] });

            this._dps.resources.push(
                {
                    id: project[groupByProperty] as string,
                    name: project[groupByProperty] as string,
                    columns: columns,
                    rawColumns: JSON.parse(JSON.stringify(columns))
                }
            );
        }
    }
    // End helper

    // Start public
    public markEvent = (id: string, slot?: ResourceSlot) => {
        this._dps.rows.selection.clear();
        const currentEvent = this._dps.events.find(this._currentlySelectedEventId);
        const newCurrentEvent = this._dps.events.find(id);
        this._currentlySelectedEventId = newCurrentEvent ? id : null;
        let isDifferentEvent = (newCurrentEvent == null || currentEvent == null || newCurrentEvent.id() !== currentEvent.id());

        if (currentEvent) {
            this._dps.events.update(currentEvent);
        }
        if (newCurrentEvent) {
            this._dps.events.update(newCurrentEvent);

            if (this.props.settings.IsMobileDevice)
                this.props.actions.openEvent(newCurrentEvent.id(), newCurrentEvent.resource());
        }

        if (this.props.selectedEventChanged)
            this.props.selectedEventChanged(this._currentlySelectedEventId, isDifferentEvent, slot);

        this._dps.separators = [];
        if (this.props.settings.ShowTargetPeriods && newCurrentEvent && Helper.hasValue(newCurrentEvent.data.versions) && newCurrentEvent.data.versions.length > 0) {
            this._dps.separators.push({ color: "red", location: newCurrentEvent.data.versions[0].start });
            this._dps.separators.push({ color: "red", location: newCurrentEvent.data.versions[0].end });
        }
        this._dps.update({ separators: this._dps.separators });
    }

    public scrollToDate = (date: string | DayPilot.Date) => {
        this._dps.scrollTo(date)
    }

    public getMarkedEvent = (): ResourcePlanningSchedulerEventViewModel => {
        if (this._currentlySelectedEventId !== null) {
            let selectedEvent = this._dps.events.find(this._currentlySelectedEventId);
            return selectedEvent != null ? this.getEventById(selectedEvent.id()) : null;
        } else
            return null;
    }

    public clearMarkedEvent = () => {
        const currentEvent = this._dps.events.find(this._currentlySelectedEventId);
        this._currentlySelectedEventId = null;
        if (currentEvent) {
            this._dps.events.update(currentEvent);
        }

        if (this.props.selectedEventChanged)
            this.props.selectedEventChanged(this._currentlySelectedEventId, true);
    }

    public focusEvent = (id: string) => {
        this._dps.events.focus(this._dps.events.find(id));
        if (this._currentlySelectedEventId !== id)
            this.markEvent(id);
    }

    public focusSlotEvent = (id: string) => {
        const slot = this._dps.events.find(id);
        this._dps.events.focus(slot);
        if (this._currentlySelectedEventId !== id) {
            const slotId = this._getSlotById(slot.data.id, slot.data.resource);
            this.markEvent(id, slotId);
        }
    }
    public getDps = () => {
        return this._dps;
    }

    public getPilotDiv = () => {
        return this._dayPilotDiv;
    }

    public partialRefresh = (type: "add" | "change" | "remove", event: ResourcePlanningSchedulerEventViewModel, doUpdate: boolean = true) => {
        //console.log("partialRefresh" + " " + type);

        this._dpsToday = DayPilot.Date.today();

        let resourceId = event.ResourceId;
        if (this.props.settings.GroupByAddresses)
            resourceId = event.AdrNr;
        else if (this.props.settings.GroupByProjects)
            resourceId = event.Projnr;
        else if (this.props.settings.GroupByMachines)
            resourceId = event.MaschNr;

        if (type == "add") {
            let resourceId = event.ResourceId;
            if (this.props.settings.GroupByProjects)
                resourceId = event.Projnr;
            else if (this.props.settings.GroupByAddresses)
                resourceId = event.AdrNr;

            event.StartPilotDate = new DayPilot.Date(event.Start);
            event.EndPilotDate = new DayPilot.Date(event.End);

            let newEvent: DayPilot.EventData = {
                id: event.Id,
                start: event.Start,
                end: event.End,
                resource: resourceId,
                text: event.Text,
                sort: this.props.settings.AssignmentSorting.map((info) =>
                    Helper.savelyToString(event[info.Field])),
                complete: event.Complete,
                startDate: kendo.parseDate(event.Start),
                endDate: kendo.parseDate(event.End)
            };

            if (Helper.hasValue(event.PMValues.Btyp) && event.PMValues.Btyp > 0 && Helper.hasValue(event.PMValues.StartSoll) && Helper.hasValue(event.PMValues.EndeSoll)) {
                newEvent.versions = [
                    {
                        start: event.PMValues.StartSoll,
                        end: event.PMValues.EndeSoll
                    }
                ]
            }
            this._data.Events.push(event);
            this._data.EventsDict[event.Id] = event;
            this._dps.events.add(newEvent);

        } else if (type == "change") {
            event.StartPilotDate = new DayPilot.Date(event.Start);
            event.EndPilotDate = new DayPilot.Date(event.End);
            let e = this._dps.events.find(event.Id);
            if (e != null) {
                const index = Helper.findIndex(this._data.Events, "Id", event.Id);
                this._data.Events[index] = event;
                this._data.EventsDict[event.Id] = event;
                e.start(new DayPilot.Date(event.Start));
                e.end(new DayPilot.Date(event.End));
                e.resource(resourceId);
                e.text(event.Text);
                //e.data.percentage = event.Utilization;
                e.data.complete = event.Complete;
                if (Helper.hasValue(event.PMValues.Btyp) && event.PMValues.Btyp > 0 && Helper.hasValue(event.PMValues.StartSoll) && Helper.hasValue(event.PMValues.EndeSoll)) {
                    e.data.versions = [
                        {
                            start: event.PMValues.StartSoll,
                            end: event.PMValues.EndeSoll
                        }
                    ]
                } else {
                    e.data.versions = [];

                }
                this._dps.events.update(e);
            }
        }
        if (type == "remove") {
            const id = event.Id;
            //remove from dps
            const e = this._dps.events.find(id);
            if (e != null)
                this._dps.events.remove(e);
            //remove from Events
            const index = Helper.findIndex(this._data.Events, "Id", id);

            //remove from dictionary
            const { [id]: omitted, ...rest } = this._data.EventsDict;
            this._data.EventsDict = rest;

            if (index > -1)
                this._data.Events.splice(index, 1);
        }

        if (!doUpdate)
            return;

        // Bei Utilization müssen die Zellen neu gerendert werden
        if (this.props.settings.ShowUtilization &&
            (this.props.settings.TimeResolutionType == this._timeResolutionTypes.Hours ||
                this.props.settings.TimeResolutionType == this._timeResolutionTypes.Days))
            this._dps.update();

        this._refreshCapacity(CapacityRefreshMode.Recompute);//danch kein dps.update() !!!!
        if (this.props.onPartialRefresh)
            this.props.onPartialRefresh(type, event);

        this._refreshLinks();
    }

    public resetLinksForPrevAssignment = (eventId: string) => {
        let events_with_prevs = this._data.Events.filter(x => x.WayThere != null && Helper.hasValue(x.WayThere.prevAssignmentId) && x.WayThere.prevAssignmentId == eventId);
        for (let i = 0; i < events_with_prevs.length; ++i) {
            let event = events_with_prevs[i];
            event.WayThere.prevAssignmentId = null;
        }
    }

    public getEventById(id: string | undefined | null): ResourcePlanningSchedulerEventViewModel {
        if (!Helper.hasValue(id))
            return null;
        return this._data.EventsDict[id];
    }

    public getResourceById(id: string | undefined | null): ResourcePlanningSchedulerResourceViewModel {
        if (!Helper.hasValue(id))
            return null;
        return this._data.ResourcesDict[id];
    }

    public refresh = (data: ResourcePlanningSchedulerDataViewModel, init: boolean, callback?: () => void) => {
        this._data = data;
        //clear events-dict
        this._data.EventsDict = {};
        this._data.ResourcesDict = {};

        //console.log("refresh => data: ", data);

        if (this._data.Resources) {
            this._data.Resources.forEach(r => {
                if (Helper.hasValue(r.Seit))
                    r.SeitAsPilotDay = new DayPilot.Date(r.Seit, true);
                if (Helper.hasValue(r.Bis))
                    r.BisAsPilotDay = new DayPilot.Date(r.Bis, true);
                this._data.ResourcesDict[r.Id] = r;
            })
        }

        this._data.Freedays.forEach(f => {
            const day = f.Day[0] + f.Day[1];
            const month = f.Day[3] + f.Day[4];
            const year = f.Day[6] + f.Day[7] + f.Day[8] + f.Day[9];
            f.DayAsPilotDate = new DayPilot.Date(
                new Date(Number(year), Number(month) - 1, Number(day), 0, 0, 0, 0), true);
        });

        return new Promise<void>(resolve => {
            setTimeout(_ => {
                let v = this._dps;

                if (!init && v.getViewPort() != null) {
                    if (v.getViewPort().resources != null && v.getViewPort().resources.length > 0) {
                        this._topResource = v.getViewPort().resources[0];
                    }
                }

                // Dynamic settings
                if (!init) {
                    this._initDynamicSettings(v);
                }

                this._dpsToday = DayPilot.Date.today();
                this.showOnlyWorkTime(true);

                v.separators = [];

                const resFilter: StringKeyDictionary<boolean> = {};
                let initialVisibility = !this.props.slotModeActive;

                if (this.props.slotModeActive && !this.props.slotSearchSettings.slotRespectSlotResourceFilter)
                    initialVisibility = true;

                this._data.Resources.forEach(r => {
                    resFilter[r.Id] = initialVisibility;
                });

                if (this.props.slotModeActive) {

                    if (this.props.slotSearchSettings.slotRespectSlotResourceFilter)
                        this.props.currentSlots.forEach(r => resFilter[r.id] = true);

                    if (this.props.slotModeSourceId) {
                        const event = this.getEventById(this.props.slotModeSourceId);
                        if (event != null)
                            resFilter[event.ResourceId] = true;
                    }
                }

                v.resources = [];

                if (this.props.settings.GroupByResources) {
                    for (let resource of this._data.Resources) {
                        if (this.props.slotModeActive && !resFilter[resource.Id]) {
                            continue;
                        }

                        let columns = [];
                        for (let column of resource.Columns)
                            columns.push({ html: column === null ? "" : column });
                        v.resources.push(
                            {
                                id: resource.Id,
                                name: resource.Text,
                                columns: columns,
                                rawColumns: JSON.parse(JSON.stringify(columns))
                            }
                        );
                    }
                } else if (this.props.settings.GroupByAddresses) {
                    this._addResources("AdrNr", this._data.Events.filter(x => !Helper.isNullOrEmpty(x.AdrNr) && !x.Hidden));
                } else if (this.props.settings.GroupByProjects) {
                    if (this.props.settings.ShowProjectStructure) {
                        this._addResourcesByProjects("ProjNr", this._data.Projects);
                    } else {
                        this._addResources("Projnr", this._data.Events.filter(x => (x.KennungTyp == Kennungstyp.Projektbezogen || x.KennungTyp == Kennungstyp.Wartung) && !x.Hidden));
                        //sortieren
                        if (Helper.hasValue(this.props.settings.SortProjectsAfterEnd) && this.props.settings.SortProjectsAfterEnd) {
                            const getValueSavely = (id: string) => {
                                const project = this._data.Projects.find(f => f.ProjNr === id.trim());
                                if (Helper.hasValue(project) && !Helper.isNullOrEmpty(project.Ende))
                                    return new Date(project.Ende).getTime();
                                else
                                    return Number.MAX_SAFE_INTEGER
                            }
                            this._dps.resources = this._dps.resources.sort((a, b) => {
                                const val_a = getValueSavely(a.id.toString());
                                const val_b = getValueSavely(b.id.toString());
                                if (val_a < val_b) {
                                    return -1;
                                }
                                if (val_a > val_b) {
                                    return 1;
                                }
                                if (a > b) {
                                    return -1;
                                }
                                if (a < b) {
                                    return 1;
                                }
                                return 0;
                            })
                        }
                    }
                } else if (this.props.settings.GroupByMachines) {
                    this._addResources("MaschNr", this._data.Events.filter(x => !Helper.isNullOrEmpty(x.MaschNr) && !x.Hidden));
                }

                v.sortDirections = this.props.settings.AssignmentSorting.map(item => item.Order)

                v.events.list = [];
                for (let event of this._data.Events) {
                    event.StartPilotDate = new DayPilot.Date(event.Start);
                    event.EndPilotDate = new DayPilot.Date(event.End);
                    this._data.EventsDict[event.Id] = event;

                    if (this.props.slotModeActive && !resFilter[event.ResourceId]) {
                        continue;
                    }

                    let resourceId = event.ResourceId;
                    if (this.props.settings.GroupByAddresses)
                        resourceId = event.AdrNr;
                    else if (this.props.settings.GroupByProjects)
                        resourceId = event.Projnr;
                    else if (this.props.settings.GroupByMachines)
                        resourceId = event.MaschNr;

                    let eventData: DayPilot.EventData = {
                        id: event.Id,
                        start: event.Start,
                        end: event.End,
                        resource: resourceId,
                        text: event.Text,
                        sort: this.props.settings.AssignmentSorting.map((info) => Helper.savelyToString(event[info.Field])),
                        hidden: event.Hidden,
                        complete: event.Complete
                    }
                    if (Helper.hasValue(event.PMValues.Btyp) && event.PMValues.Btyp > 0 && Helper.hasValue(event.PMValues.StartSoll) && Helper.hasValue(event.PMValues.EndeSoll)) {
                        eventData.versions = [
                            {
                                start: event.PMValues.StartSoll,
                                end: event.PMValues.EndeSoll
                            }
                        ]
                    }
                    v.events.list.push(eventData);
                }

                for (let resource of this.props.currentSlots) {
                    for (let slot of resource.slots) {
                        v.events.list.push({
                            id: slot.id,
                            start: Helper.dates.getISODateString(slot.startDate),
                            end: Helper.dates.getISODateString(slot.endDate),
                            resource: resource.id,
                            text: "Free slot",
                            sort: [Helper.dates.getISODateString(slot.startDate), slot.id]
                        });
                    }
                }

                this._refreshLinks();
                this._currentlySelectedEventId = null;

                v.rows.selection.clear();

                v.update();

                if (this._topResource != null)
                    v.scrollToResource(this._topResource);

                v.clearSelection();
                v.multiselect.clear();
                v.rows.selection.clear();

                if (this.state.lastSelectedRow) {
                    const row = this._dps.rows.find(r => r.id == this.state.lastSelectedRow);
                    if (row) {
                        v.rows.selection.add(row);
                        v.rows.update(row);
                    }
                }

                if (this.props.selectedEventChanged)
                    this.props.selectedEventChanged(this._currentlySelectedEventId, true);

                if (init && this.props.settings.InitialProjNr != null && this.props.settings.InitialPIndex != null) {
                    let event = this._dps.events.find(this.props.settings.InitialProjNr + "|" + this.props.settings.InitialPIndex);
                    if (event != null) {
                        this.markEvent(event.id());
                        //this.props.actions.openEvent(event.id(), event.resource());
                    }
                }

                this._refreshCapacity(CapacityRefreshMode.Recompute);

                if (callback)
                    callback();

                resolve();
            }, 1);
        });
    }

    //...
    public toggleCapacity = (isOn: boolean, after: () => void = null) => {
        this.setState({ capacityIsOn: isOn }, () => {
            this._dps.show();
            if (this.state.capacityIsOn) {
                //the scrollbar can appear after the scheduler layout "refresh"
                this._updateCapacityDiagramPaddingFiller();
                if (this._assignmentArea)
                    this._onHorizontalScroll(this._assignmentArea.scrollLeft());
            }
            if (Helper.hasValue(after)) {
                after();
            }
        });
    }

    public selectResource = (id: string, selectedRow: boolean = false) => {
        this._dps.scrollToResource(id);
        if (selectedRow) {
            this._dps.rows.selection.clear();
            const row = this._dps.rows.find(r => r.id == id);
            if (row)
                this._dps.rows.selection.add(row);

            if (this.state.lastSelectedRow) {
                const oldRow = this._dps.rows.find(r => r.id == this.state.lastSelectedRow);
                if (oldRow)
                    this._dps.rows.update(oldRow);
            }
            this.setState({ lastSelectedRow: row.id })
        }
    }

    public dropCapacityDiagramAwaitTrigger = () => {
        this._capacityDiagram.dropAwaitTrigger();
    }

    public scrollToStart = () => {
        this._dps.scrollTo(this.props.settings.Start);
    }

    public selectAllResources = () => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.selectAllResources(true);
        }
    }

    public deselectAllResources = () => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.deselectAllResources(true);
        }
    }

    private _handleResourceDoubleClick = (event: any) => {
        if (this.state.capacityIsOn) {
            this._capacityDiagram.handleResourceDoubleClick(event.resource as any as DayPilot.Row, true);
        }
    }

    public refreshCapacity = (mode: CapacityRefreshMode) => {
        this._refreshCapacity(mode);
    }

    public setConsiderHiddenAssignmentsForCapacity = (considerHidden: boolean) => {
        this._capacityDiagram.setConsiderHiddenAssignmentsForComputation(considerHidden);
    }

    private renderWorkingtime(workStart: DayPilot.Date, workEnd: DayPilot.Date, args: any, backgroundColor: string, event: ResourcePlanningSchedulerEventViewModel, textIconLayer: string, borderWidth: string) {
        const schedulerStart = (this._dps.startDate as DayPilot.Date);
        const schedulerEnd = (this._dps.startDate as DayPilot.Date).addDays(this._dps.days);
        const start = workStart < schedulerStart ? schedulerStart.getDatePart() : workStart.getDatePart();
        const end = workEnd > schedulerEnd ? schedulerEnd.getDatePart() : workEnd.getDatePart();
        let currentday = start.getDatePart();

        args.data.areas.push({ start: workStart, end: workEnd, top: 0, bottom: 0, style: `margin-top:1px;margin-bottom:1px;padding: 2px;background-color:${backgroundColor}` });
        if (this.props.settings.ShowFreeWeekeend && this.props.settings.FlagMode == 0 && !this.props.settings.AssignmentGroupingViewActive) {
            this.renderWeekends(event, start, end, currentday, workStart, workEnd, args);
        }
        args.data.areas.push({ start: workStart, end: workEnd, top: 0, bottom: 0, html: textIconLayer, style: `margin-top:1px;margin-bottom:1px;padding: 2px; color: white;border: ${borderWidth} solid ${event.BorderColor}` });
    }

    private renderWeekends(event: ResourcePlanningSchedulerEventViewModel, start: DayPilot.Date, end: DayPilot.Date, currentday: DayPilot.Date, workStart: DayPilot.Date, workEnd: DayPilot.Date, args: any) {
        if (event.KennungTyp !== Kennungstyp.Urlaub) {
            const resource = this.getResourceById(event.ResourceId);
            if (!resource) return; //this is normal => this._data was updated, but DayPilot not yet ...  

            const dpsStart = (this._dps.startDate as DayPilot.Date);

            const schedulerEvent: DayPilot.EventData = args.e;

            const eventStartAsDate = (schedulerEvent.start as DayPilot.Date);//.toDateLocal();
            const eventEndAsDate = (schedulerEvent.end as DayPilot.Date);//.toDateLocal();

            for (let d = start; d <= end; d = d.addDays(1)) {
                const newEnd = currentday.addDays(1);

                //const currentdayDate = currentday.toDateLocal();

                const dayOffsetRoster = this.dayPilotDateDiffInDays(dpsStart, currentday)
                const dayInfo = GetRosterInfoFromArray(this._data.RosterDayInfos, resource.RosterDayInfo, dayOffsetRoster);

                let idx = -1;
                if (this.isDayPilotDateInBetween(currentday, eventStartAsDate, eventEndAsDate)) {
                    if (event.AssignmentUtilizationInfo.offset >= 0)
                        idx = this.dayPilotDateDiffInDays(eventStartAsDate, currentday);
                    else
                        idx = this.dayPilotDateDiffInDays(dpsStart, currentday);
                }

                if (dayInfo != null && idx > -1) {
                    let dayUtil: number = 0;
                    if (event.AssignmentUtilizationInfo != null) {
                        dayUtil = this.props.settings.IgnoreUtilTravelTimes ? event.AssignmentUtilizationInfo.work[idx] / 60 :
                            (event.AssignmentUtilizationInfo.arrival[idx] + event.AssignmentUtilizationInfo.work[idx] + event.AssignmentUtilizationInfo.departure[idx]) / 60;
                    }
                    //working weekends
                    const showOnlyWorktime = this.showOnlyWorkTime(false);
                    if (!showOnlyWorktime && IsWeekend(dayInfo) && dayUtil == 0) {
                        const weekendDays = this.props.settings.AllWeekendDays.filter(x => x.Id == resource.WochenendId && x.DayOfWeek == currentday.getDayOfWeek());
                        const area: any = {
                            start: workStart.getDatePart() == currentday ? workStart : currentday,
                            end: workEnd.getDatePart() == currentday ? workEnd : newEnd,
                            top: 0,
                            bottom: 0
                        };
                        if (weekendDays && weekendDays.length > 0) {
                            area.style = `background-color:${weekendDays[0].Color}`;
                        } else {
                            area.cssClass = SchedulerClasses.WeekEnd;
                        }
                        args.data.areas.push(area);
                    }

                    //working holidays
                    if (IsHoliday(dayInfo) && dayUtil == 0) {
                        const kalenderId = this._data.SettingsPlanningBoard.SpecialCalendarActivated ? resource.KalenderId : -1;
                        //let dateAsddMMyyyy = currentday.toString("dd.MM.yyyy");
                        let filterFreedays = this._data.Freedays.filter(x => x.KalenderId == kalenderId
                            && (x.DayAsPilotDate == currentday));
                        if (filterFreedays.length > 0) {
                            const area: any = {
                                start: workStart.getDatePart() == currentday ? workStart : currentday,
                                end: workEnd.getDatePart() == currentday ? workEnd : newEnd,
                                top: 0,
                                bottom: 0
                            };
                            area.style = `background-color:${filterFreedays[0].Color}`;
                            args.data.areas.push(area);
                        }
                    }
                }

                currentday = currentday.addDays(1);
            }
        }
        return currentday;
    }


    private showOnlyWorkTime = (doUpdate: boolean) => {
        if (doUpdate) {
            const filterResourceForWorktime = (resource: ResourcePlanningSchedulerResourceViewModel) => {
                return resource.Id.includes("r|") &&
                    Helper.hasValue(resource.WochenendId) &&
                    (this.props.settings.AllWeekendDays.findIndex(schema => schema.Id == resource.WochenendId) > -1);
            }
            this._showOnlyWorkTime = this.props.settings.ShowOnlyWorktime &&
                (this.props.settings.AllWeekendDays.length == 0 || this._data.Resources.filter(filterResourceForWorktime).length === 0);
        }
        return this._showOnlyWorkTime;
    }
    // End public 

    componentDidMount() {
        //console.log("scheduler - componentDidMount");
        $(document).on("keydown keyup", (ev) => {
            if (ev.type === "keydown") {
                this._ctrlPressed = false;
                if (ev.ctrlKey) {
                    this._ctrlPressed = true;
                }
            } else {
                this._ctrlPressed = false;
            }
        })

        window.addEventListener('blur', () => {
            this._ctrlPressed = false;
            
        });


        if (this._dayPilotDiv) {
            this._dayPilotDiv.addEventListener("mousedown", () => {
                this._dayPilotDiv.focus();
            });
        }

        this._data = this.props.initialData;

        this._init();
        //todo: check this 
        this.refresh(this._data, true).then(_ => {
            this._assignmentArea = $("." + SchedulerClasses.Scrollable);

            //the capacity diagram needs this._dps
            //update to init the diagram component
            this.setState({}, () => {
                //capacity
                this._assignmentArea.on("scroll", () => this._onHorizontalScroll(this._assignmentArea.scrollLeft()));

                this._assignmentArea.on("scroll", () => {
                    this._onHorizontalScroll(this._assignmentArea.scrollLeft());
                    //AG fix für hint
                    if (this._schedulerTimeRangeSelectingArgs &&
                        this._dps.rows.find(r => r.id == this._schedulerTimeRangeSelectingArgs.resource)) {
                            this._dps.clearSelection();
                            try {
                                this._dps.selectTimeRange(this._schedulerTimeRangeSelectingArgs.start,
                                    this._schedulerTimeRangeSelectingArgs.end,
                                    this._schedulerTimeRangeSelectingArgs.resource);
                            }
                            catch {
                                //ok 
                            }
                    }
                });
                
                //performance...
                //update outside of react
                //setState would trigger a "refresh" on the capacity calculation...
                $(window).on("resize", this._updateCapacityDiagramPaddingFiller);
                const el = document.querySelector('div.scheduler_white_columnheader_cell');
                this.resizeObserver.observe(el)
                this.props.afterSchedulerLoaded();

                $(window).trigger("selectAssignmentOnInit");
            });
        });
    }

    render() {
        return (
            <>
                <div id={"globalSchedulerDiv"} ref={(e) => this._dayPilotDiv = e} tabIndex={0} style={{ outline: 'none' }} />
                {Helper.hasValue(this._dps) ?
                    <Diagram
                        ref={r => this._capacityDiagram = r}
                        showDiagram={this.state.capacityIsOn}
                        afterDiagramLoaded={this.props.afterDiagramLoaded}
                        getData={() => {
                            return {
                                settings: this._data.CapacitySettings,
                                scheduler: this._dps,
                                startDate: Helper.dates.toDate(this._data.SettingsPlanningBoard.Start),
                                endDate: Helper.dates.toDate(this._data.SettingsPlanningBoard.End),
                                scale: this._data.SettingsPlanningBoard.Scale,
                                initialScrollPosition: this._schedulerCurrentX,
                                translations: this.props.translations,
                                renderScrollBarPadding: this._hasScrollBar(),
                                assignments: this._data.Events,
                                resources: this._data.Resources,
                                settingsPlanningBoard: this._data.SettingsPlanningBoard,
                                ignoreUtilTravelTimes: this.props.settings.IgnoreUtilTravelTimes,
                                rosterDayInfos: this._data.RosterDayInfos
                            }
                        }} />
                    : null
                }
            </>
        );
    }
}

export const SchedulerLocaleLabels: StringKeyDictionary<SchedulerLocaleLabelData> = {
    "en-gb": {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    "de-de": {
        days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthsShort: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    }
}

export enum SchedulerClasses {
    Scrollable = "scheduler_white_scrollable",
    //EventSelected = "scheduler_white_event_selected",
    FreeDay = "scheduler_white_cellcolumn_freeday",
    CurrentDay = "scheduler_innosoft_cellcolumn_currentday",
    //EventHidden = "scheduler_innosoft_event_hidden",
    WeekEnd = "scheduler_innosoft_cellcolumn_weekend",
    WeekEndSchema = "scheduler_innosoft_cellcolumn_weekendschema_",
    Overload = "scheduler_innosoft_cell_overload",
    FixedStart = "scheduler_white_event_fixedStart",
    FixedEnd = "scheduler_white_event_fixedEnd",
    FixedResource = "scheduler_white_event_fixedResource"
}

export enum SchedulerResourceHeaderClasses {
    //HeaderContainer = "resource-header__header-container",
    NameColumn = "resource-header__main-column",
    Column = "resource-header__column, truncate",
    Resource = "resource-header--resource",
    Container = "resource-header--container",
    Selected = "resource-header--selected",
    External = "resource-header--external",
    Overload = "resource-header--overload"
}

interface SchedulerLocaleLabelData {
    days: Array<string>;
    daysShort: Array<string>;
    months: Array<string>;
    monthsShort: Array<string>;
}

interface SchedulerProps {
    settings: ResourcePlanningSchedulerSettingsViewModel;
    lookups: any;
    initialData: ResourcePlanningSchedulerDataViewModel;
    translations: StringKeyDictionary<string>;
    actions: ResourcePlanningSchedulerActions;
    selectedResourceChanged?: (resourceId: string, selected: boolean) => void;
    selectedTimeRangeChanged?: (resourceId: string, date: Date) => void;
    selectedEventChanged?: (eventId: string, isDifferentEvent?: boolean, slot?: ResourceSlot) => void;
    onHorizontalScroll?: (x: number) => void;
    onPartialRefresh?: (type: "add" | "change" | "remove", event: ResourcePlanningSchedulerEventViewModel) => void;
    timeHeaderClicked?: (args: any) => void;
    currentSlots: Array<ResourceWithSlots>;
    slotModeActive: boolean;
    slotModeSourceId: string;
    geomapViewMode: GeomapViewMode;
    geomapRouteColors?: Array<RouteColors>;
    afterSchedulerLoaded: () => void;
    multiSelectActive: boolean;
    initialResource?: string;
    afterDiagramLoaded?: () => void;
    templateFunc: (data: any) => string;
    hintTemplateFunc: (data: any) => string;
    slotSearchSettings: SlotSearchSettings;
    columnTemplate?: string;
}

interface OnBeforeTimeHeaderRenderArgs {
    header: TimeHeader;
}

interface TimeHeader {
    backColor: string,
    cssClass: string,
    end: DayPilot.Date,
    html: string,
    level: number,
    start: DayPilot.Date,
    toolTip: string,
    text: string,
}

interface ColorsWithId {
    id: number;
    colorName: string;
}

export interface SendStateInfo {
    Id?: number;
    Name: string;
    IconCode: string;
    IconColor: string;
}

export enum JourneyLegKind {
    NoGeoData = 0,
    AirwayCalculation = 1,
    CarDriving = 2,
    Airplane = 3,
}